{
  "site.description": "Verwaltungsplattform für Vermieter",
  "appAdvertising.ariaLabel": "Gesponserter Bereich",
  "appAdvertising.eyebrow": "Gesponsert",
  "appAdvertising.title": "Eine passende Partnerkampagne fur Vermieter",
  "appAdvertising.body": "Dieser dezente Platz ist fur eine vertikale Kampagne oder Partnerbotschaft vorgesehen, die zum taglichen Immobilienmanagement passt.",
  "appAdvertising.meta": "Admins konnen diesen Bereich plattformweit deaktivieren.",
  "language.label": "Sprache",
  "language.nl": "Niederländisch",
  "language.fr": "Französisch",
  "language.en": "Englisch",
  "language.de": "Deutsch",
  "common.loading": "Wird geladen...",
  "common.today": "heute",
  "common.tomorrow": "morgen",
  "common.actions": "Aktionen",
  "common.details": "Details",
  "common.edit": "Bearbeiten",
  "common.delete": "Löschen",
  "common.download": "Herunterladen",
  "common.upload": "Hochladen",
  "common.uploading": "Wird hochgeladen...",
  "common.add": "Hinzufügen",
  "common.create": "Erstellen",
  "common.save": "Speichern",
  "common.saving": "Wird gespeichert...",
  "common.deleting": "Wird gelöscht...",
  "common.cancel": "Abbrechen",
  "common.close": "Schließen",
  "common.copy": "Kopieren",
  "common.next": "Weiter",
  "common.previous": "Zurück",
  "common.finish": "Fertig",
  "common.confirm": "Bestätigen",
  "common.all": "Alle",
  "common.none": "Keine",
  "common.open": "Offen",
  "common.completed": "Abgeschlossen",
  "common.overdue": "Überfällig",
  "common.soon": "Bald",
  "common.active": "Aktiv",
  "common.ended": "Beendet",
  "common.status": "Status",
  "common.type": "Typ",
  "common.title": "Titel",
  "common.date": "Datum",
  "common.description": "Beschreibung",
  "common.notes": "Notizen",
  "common.notesPlaceholder": "Absprachen, besondere Klauseln, Links oder interne Notizen...",
  "common.tags": "Tags",
  "common.address": "Adresse",
  "common.property": "Immobilie",
  "common.tenant": "Mieter",
  "common.photos": "Fotos",
  "common.document": "Dokument",
  "common.documents": "Dokumente",
  "common.reminder": "Erinnerung",
  "common.reminders": "Erinnerungen",
  "common.deadline": "Frist",
  "common.startDate": "Startdatum",
  "common.endDate": "Enddatum",
  "common.name": "Name",
  "common.email": "E-Mail",
  "common.phone": "Telefon",
  "common.phoneNumber": "Telefonnummer",
  "common.file": "Datei",
  "common.expiryDate": "Ablaufdatum",
  "common.added": "Hinzugefügt",
  "common.linkedTo": "Verknüpft mit",
  "common.noLink": "- Keine Verknüpfung -",
  "common.optional": "(optional)",
  "common.required": "*",
  "common.orSkip": "oder diesen Schritt überspringen",
  "common.errorGeneric": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  "apiError.invalidRequest": "Die Anfrage ist unvollstandig oder ungueltig.",
  "apiError.badRequest": "Die Anfrage konnte nicht verarbeitet werden.",
  "apiError.unauthorized": "Ihre Sitzung konnte nicht uberpruft werden. Bitte melden Sie sich erneut an.",
  "apiError.paymentRequired": "Ihr Abonnement erlaubt diese Aktion derzeit nicht.",
  "apiError.forbidden": "Sie durfen diese Aktion nicht ausfuhren.",
  "apiError.notFound": "Der angeforderte Eintrag wurde nicht gefunden.",
  "apiError.conflict": "Diese Aktion kann derzeit nicht abgeschlossen werden.",
  "apiError.invalidOperation": "Diese Aktion kann nicht abgeschlossen werden.",
  "apiError.invalidVatNumber": "Die USt-Nummer ist ungueltig. Prufen Sie die Nummer und versuchen Sie es erneut.",
  "apiError.argument": "Einige Angaben sind ungueltig. Prufen Sie Ihre Eingaben und versuchen Sie es erneut.",
  "apiError.argumentOutOfRange": "Einer der Werte liegt ausserhalb des erlaubten Bereichs.",
  "apiError.billingProvider": "Der Zahlungsanbieter konnte diese Aktion derzeit nicht abschliessen.",
  "auth.login": "Anmelden",
  "auth.logout": "Abmelden",
  "auth.startFree": "Kostenlos starten",
  "auth.dashboard": "Dashboard",
  "auth.successTitle": "Prufen Sie Ihr Postfach",
  "auth.loginWithEmail": "Anmeldelink senden",
  "auth.loginWithGoogle": "Mit Google anmelden",
  "auth.loginWithMicrosoft": "Mit Microsoft anmelden",
  "auth.emailLabel": "E-Mail-Adresse",
  "auth.emailPlaceholder": "name@beispiel.de",
  "auth.emailRequired": "Geben Sie zuerst Ihre E-Mail-Adresse ein.",
  "auth.emailLinkSent": "Wir haben einen Anmeldelink an Ihre E-Mail-Adresse gesendet.",
  "auth.emailLoginFailed": "Die Anmeldung per E-Mail ist fehlgeschlagen.",
  "auth.emailProvider": "E-Mail",
  "auth.loggingIn": "Anmeldung läuft...",
  "auth.googleLoginFailed": "Die Google-Anmeldung ist fehlgeschlagen.",
  "auth.microsoftLoginFailed": "Die Microsoft-Anmeldung ist fehlgeschlagen.",
  "auth.loginUnavailable": "Die Anmeldung ist derzeit nicht verfugbar. Bitte versuchen Sie es spater erneut.",
  "auth.noLoginProviders": "Derzeit sind keine Anmeldemethoden verfugbar.",
  "auth.authProviderDisabled": "Diese Anmeldemethode ist derzeit deaktiviert.",
  "auth.signupDisabled": "Neue Konten sind derzeit deaktiviert. Bitte kontaktieren Sie den Helpdesk.",
  "auth.signupNotification.body": "Hinterlassen Sie Ihre E-Mail-Adresse, wenn Sie eine einmalige E-Mail erhalten mochten, sobald Rentomax wieder fur neue Benutzer verfugbar ist.",
  "auth.signupNotification.emailLabel": "E-Mail-Adresse",
  "auth.signupNotification.emailPlaceholder": "name@beispiel.de",
  "auth.signupNotification.submit": "Benachrichtigen",
  "auth.signupNotification.successTitle": "Sie stehen auf der Liste",
  "auth.signupNotification.success": "Wir senden Ihnen eine einmalige E-Mail, sobald neue Konten wieder zugelassen sind.",
  "auth.signupNotification.invalidEmail": "Geben Sie eine gultige E-Mail-Adresse ein.",
  "auth.signupNotification.missingContext": "Ihr Anmeldekontext konnte nicht mehr verifiziert werden. Bitte melden Sie sich erneut an.",
  "auth.signupNotification.saveError": "Ihre Anfrage konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
  "accessGuard.checkFailed": "Ihr Zugriff konnte gerade nicht geprueft werden. Bitte versuchen Sie es erneut.",
  "auth.errorTitle": "Anmeldung nicht verfügbar",
  "auth.countryNotAllowed": "Rentomax ist in Ihrem Land noch nicht verfügbar.",
  "auth.platformCountryNotAllowed": "Ihre Sitzung wurde beendet, weil der Zugriff aus Ihrem Land auf Rentomax nicht erlaubt ist.",
  "auth.countryUnverified": "Ihr Land konnte nicht verifiziert werden. Bitte versuchen Sie es später erneut.",
  "country.AT": "Oesterreich",
  "country.BE": "Belgien",
  "country.BG": "Bulgarien",
  "country.HR": "Kroatien",
  "country.CY": "Zypern",
  "country.CZ": "Tschechien",
  "country.DK": "Daenemark",
  "country.EE": "Estland",
  "country.FI": "Finnland",
  "country.FR": "Frankreich",
  "country.DE": "Deutschland",
  "country.GR": "Griechenland",
  "country.HU": "Ungarn",
  "country.IE": "Irland",
  "country.IT": "Italien",
  "country.LV": "Lettland",
  "country.LT": "Litauen",
  "country.LU": "Luxemburg",
  "country.MT": "Malta",
  "country.NL": "Niederlande",
  "country.PL": "Polen",
  "country.PT": "Portugal",
  "country.RO": "Rumaenien",
  "country.SK": "Slowakei",
  "country.SI": "Slowenien",
  "country.ES": "Spanien",
  "country.SE": "Schweden",
  "nav.dashboard": "Dashboard",
  "nav.calendar": "Kalender",
  "nav.properties": "Immobilien",
  "nav.tenants": "Mieter",
  "nav.documents": "Dokumente",
  "nav.reminders": "Erinnerungen",
  "nav.damageReports": "Schadensmeldungen",
  "nav.waitinglist": "Warteliste",
  "nav.contractors": "Auftragnehmer",
  "nav.features": "Funktionen",
  "nav.pricing": "Preise",
  "nav.help": "Hilfe",
  "nav.tenantActiveAgreements": "Aktive Mietverhältnisse",
  "nav.tenantUpcomingAgreements": "Zukünftige Mietverhältnisse",
  "nav.tenantApplications": "Bewerbungen",
  "nav.tenantPastAgreements": "Vergangene Mietverhältnisse",
  "footer.tagline": "Die smarte Plattform für Vermieter in Belgien und den Niederlanden.",
  "footer.product": "Produkt",
  "footer.support": "Support",
  "footer.contact": "Kontakt",
  "footer.legal": "Rechtliches",
  "footer.privacy": "Datenschutzerklarung",
  "footer.terms": "Nutzungsbedingungen",
  "footer.copyright": "Alle Rechte vorbehalten.",
  "legal.eyebrow": "Legal",
  "legal.updated": "Zuletzt aktualisiert: 23. Juni 2026",
  "legal.common.companyLabel": "Unternehmen",
  "legal.common.addressLabel": "Niederlassungsland",
  "legal.common.companyNumberLabel": "Unternehmensnummer",
  "legal.common.vatLabel": "USt-IdNr.",
  "legal.common.emailLabel": "E-Mail",
  "legal.common.websiteLabel": "Website",
  "legal.privacy.hero.title": "Datenschutzerklarung",
  "legal.privacy.hero.body": "Diese Datenschutzerklarung beschreibt, wie Ceustermans IT BV personenbezogene Daten im Zusammenhang mit Rentomax und der offentlichen Website verarbeitet.",
  "legal.privacy.controller.title": "1. Verantwortlicher",
  "legal.privacy.controller.body": "Ceustermans IT BV ist der Verantwortliche fur die uber Rentomax und die offentliche Website verarbeiteten personenbezogenen Daten.",
  "legal.privacy.scope.title": "2. Welche Daten umfasst diese Richtlinie?",
  "legal.privacy.scope.body": "Diese Richtlinie gilt fur personenbezogene Daten, die wir verarbeiten, wenn Sie die Website besuchen, ein Konto erstellen, sich anmelden, Support anfordern, eine Testphase oder ein Abonnement nutzen oder Daten in Rentomax speichern.",
  "legal.privacy.scope.item1": "Identitats- und Kontaktdaten wie Name, E-Mail-Adresse, Telefonnummer und Adressdaten.",
  "legal.privacy.scope.item2": "Konto- und Profildaten wie Kontotyp, Sprachpraferenz, Anmeldeanbieter und Onboarding-Status.",
  "legal.privacy.scope.item3": "Abonnement- und Rechnungsdaten wie gewahlter Tarif, Zahlungsstatus, Rechnungen, Gutschriften sowie Unternehmens- oder USt-Daten.",
  "legal.privacy.scope.item4": "Nutzerinhalte, die im Dienst gespeichert werden, wie Immobilien, Mieter, Vereinbarungen, Dokumente, Fotos, Erinnerungen und Meldungen.",
  "legal.privacy.scope.item5": "Technische Daten wie IP-Adresse, Gerate- und Browserinformationen, Protokolle und lokale Einstellungen, die fur Sicherheit und Betrieb erforderlich sind.",
  "legal.privacy.collection.title": "3. Wie erfassen wir personenbezogene Daten?",
  "legal.privacy.collection.item1": "Direkt von Ihnen, wenn Sie Formulare ausfullen, sich anmelden, Support anfordern oder Daten in der App speichern.",
  "legal.privacy.collection.item2": "Uber Google oder Microsoft, wenn Sie sich fur eine Anmeldung mit einem dieser Anbieter entscheiden.",
  "legal.privacy.collection.item3": "Uber Zahlungs- und Abrechnungspartner, wenn eine Testphase, Zahlung, Abonnementanderung oder Ruckerstattung verarbeitet wird.",
  "legal.privacy.collection.item4": "Automatisch uber Protokolle, Cookies und lokale Speicherung, die erforderlich sind, um Website und App sicher und nutzbar zu halten.",
  "legal.privacy.google.title": "4. Google-Nutzerdaten fur die Anmeldung",
  "legal.privacy.google.body1": "Wenn Sie Sign in with Google auswahlen, fordert Rentomax nur die Scopes openid, email und profile an. Uber diese Scopes erhalten wir Ihre Google-Konto-ID, E-Mail-Adresse und Ihren Profilnamen.",
  "legal.privacy.google.body2": "Wir verwenden diese Google-Nutzerdaten nur, um Sie zu authentifizieren, Ihr Rentomax-Konto zu erstellen oder zu verknupfen, den gewahlten Anmeldeanbieter zu speichern und Ihren Namen oder Ihre E-Mail-Adresse in Ihrem Konto anzuzeigen. Wir verwenden diese Daten nicht fur Werbung und nicht zum Trainieren verallgemeinerter KI- oder ML-Modelle.",
  "legal.privacy.google.item1": "Der Autorisierungscode und die von Google wahrend der Anmeldung zuruckgegebenen Tokens werden nur im Backend-Anmeldeablauf verwendet, um Ihre Identitat zu verifizieren.",
  "legal.privacy.google.item2": "Wir verwenden das Google-Access-Token nicht, um Gmail, Drive, Calendar, Contacts oder andere Google-APIs zu lesen oder zu andern, und wir speichern dieses Access-Token nach der Anmeldung nicht.",
  "legal.privacy.google.item3": "Wir konnen die Google-Konto-ID, die E-Mail-Adresse und den Profilnamen in Ihrem Rentomax-Kontodatensatz fur Kontozugang, Sicherheit, Support und Kontowiederherstellung speichern oder langer, wenn eine gesetzliche Aufbewahrungspflicht gilt.",
  "legal.privacy.purposes.title": "5. Warum verarbeiten wir personenbezogene Daten und auf welcher Rechtsgrundlage?",
  "legal.privacy.purposes.item1": "Um Ihr Konto zu erstellen, Sie zu authentifizieren und Ihnen Zugang zu Rentomax zu geben. Rechtsgrundlage: Vertragserfullung oder vorvertragliche Schritte.",
  "legal.privacy.purposes.item2": "Um den Dienst bereitzustellen, Daten zu speichern, Dossiers anzuzeigen und Funktionen wie Dokumente, Fotos, Erinnerungen und Mieterablaufe zu betreiben. Rechtsgrundlage: Vertragserfullung.",
  "legal.privacy.purposes.item3": "Um Zahlungen, Abonnements, Rechnungen, Ruckerstattungen und erforderliche Buchhaltungsprozesse zu verwalten. Rechtsgrundlage: Vertragserfullung und gesetzliche Verpflichtungen.",
  "legal.privacy.purposes.item4": "Um Supportanfragen zu beantworten und betriebliche Nachrichten zu senden. Rechtsgrundlage: berechtigte Interessen und, soweit relevant, vorvertragliche Schritte.",
  "legal.privacy.purposes.item5": "Um Website und App zu sichern, Missbrauch zu verhindern, Vorfalle zu untersuchen und die Leistung zu uberwachen. Rechtsgrundlage: berechtigte Interessen.",
  "legal.privacy.purposes.item6": "Um Ihnen eine einmalige Nachricht zu senden, wenn der Zugang fur neue Konten wieder geoffnet wird, falls Sie dies ausdrucklich anfordern. Rechtsgrundlage: Einwilligung.",
  "legal.privacy.cookies.title": "6. Cookies, lokale Speicherung und Anmeldetechnologie",
  "legal.privacy.cookies.body1": "Rentomax verwendet funktionale Cookies und lokale Speicherung, um Website und App zu betreiben, zum Beispiel fur Sprachwahl, Sitzungssicherheit, Anmeldestatus, Weiterleitungen nach der Anmeldung, Einwilligungsentscheidungen und Oberflachenpraferenzen.",
  "legal.privacy.cookies.body2": "Wenn Sie Google- oder Microsoft-Anmeldung wahlen, laden wir die erforderlichen Anmeldeskripte dieser Anbieter, um die Authentifizierung zu ermoglichen. Diese Anbieter verarbeiten dabei ebenfalls Daten nach ihren eigenen Datenschutzbestimmungen.",
  "legal.privacy.sharing.title": "7. Mit wem teilen wir personenbezogene Daten?",
  "legal.privacy.sharing.body": "Wir verkaufen Ihre personenbezogenen Daten nicht. Wir teilen personenbezogene Daten nur, wenn dies fur die Bereitstellung von Rentomax, die Zahlungsabwicklung, das Hosting, den E-Mail-Versand, den Schutz des Dienstes oder zur Einhaltung gesetzlicher Pflichten erforderlich ist.",
  "legal.privacy.sharing.item1": "Zahlungsabwicklung und Abonnementverwaltung uber Mollie.",
  "legal.privacy.sharing.item2": "Authentifizierung uber Google und Microsoft, wenn Sie diese Anmeldemethoden verwenden.",
  "legal.privacy.sharing.item3": "Speicherung und Infrastruktur uber Supabase und Azure.",
  "legal.privacy.sharing.item4": "Transaktionaler E-Mail-Versand uber Resend.",
  "legal.privacy.sharing.item5": "Berater, zustandige Behorden oder Gerichte, wenn dies verhaltnismassig erforderlich oder gesetzlich vorgeschrieben ist.",
  "legal.privacy.transfers.title": "8. Internationale Datenubertragungen",
  "legal.privacy.transfers.body": "Einige Anbieter oder deren Unterauftragsverarbeiter konnen personenbezogene Daten ausserhalb des Europaischen Wirtschaftsraums verarbeiten. In diesem Fall stutzen wir uns auf einen gultigen Ubermittlungsmechanismus, etwa einen Angemessenheitsbeschluss oder geeignete vertragliche Garantien.",
  "legal.privacy.retention.title": "9. Speicherfristen",
  "legal.privacy.retention.body1": "Wir speichern personenbezogene Daten nicht langer als fur die Zwecke erforderlich, fur die sie erhoben wurden, es sei denn, eine langere Aufbewahrung ist gesetzlich vorgeschrieben oder betrieblich gerechtfertigt.",
  "legal.privacy.retention.item1": "Konto- und Dossierdaten werden grundsatzlich solange gespeichert, wie das Konto aktiv ist, und anschliessend solange, wie es fur Abschluss, Backups, Streitigkeiten oder gesetzliche Pflichten notwendig ist.",
  "legal.privacy.retention.item2": "Abrechnungs- und Transaktionsunterlagen werden so lange gespeichert, wie dies nach den anwendbaren Buchhaltungs- und Steuervorschriften erforderlich ist.",
  "legal.privacy.retention.item3": "Supportanfragen, Sicherheitsprotokolle und technische Backups werden solange aufbewahrt, wie dies fur Support, Sicherheit und Wiederherstellung verhaltnismassig erforderlich ist.",
  "legal.privacy.security.title": "10. Sicherheit",
  "legal.privacy.security.body": "Wir ergreifen angemessene technische und organisatorische Massnahmen, um personenbezogene Daten vor Verlust, unbefugtem Zugriff, Missbrauch, Anderung oder Offenlegung zu schutzen. Keine Speicher- oder Ubertragungsmethode ist jedoch vollstandig risikofrei.",
  "legal.privacy.rights.title": "11. Ihre Rechte",
  "legal.privacy.rights.body": "Nach der DSGVO haben Sie je nach Situation moglicherweise Rechte auf Auskunft, Berichtigung, Loschung, Einschrankung, Datenubertragbarkeit und Widerspruch gegen bestimmte Verarbeitungen. Wenn die Verarbeitung auf Einwilligung beruht, konnen Sie diese auch widerrufen.",
  "legal.privacy.rights.body2": "Sie konnen Ihre Anfrage an <a href=\"mailto:admin@rentomax.be\">admin@rentomax.be</a> senden. Wir konnen eine angemessene Verifizierung verlangen, bevor wir auf eine Anfrage reagieren.",
  "legal.privacy.complaints.title": "12. Beschwerden und Kontakt",
  "legal.privacy.complaints.body1": "Wenn Sie Fragen zu dieser Datenschutzerklarung oder zur Verarbeitung personenbezogener Daten durch Rentomax haben, kontaktieren Sie uns unter <a href=\"mailto:admin@rentomax.be\">admin@rentomax.be</a>.",
  "legal.privacy.complaints.body2": "Sie haben ausserdem das Recht, eine Beschwerde bei der belgischen Datenschutzbehorde oder bei der Aufsichtsbehorde in dem EU-Land einzureichen, in dem Sie wohnen oder arbeiten.",
  "legal.terms.hero.title": "Nutzungsbedingungen",
  "legal.terms.hero.body": "Diese Bedingungen regeln Ihren Zugang zu Rentomax und dessen Nutzung als administrative Software fur Vermieter und Vermietungsunternehmen.",
  "legal.terms.provider.title": "1. Anbieter",
  "legal.terms.provider.body": "Rentomax wird von Ceustermans IT BV, Belgien, Unternehmensnummer 0783 289 846 und USt-IdNr. BE0783 289 846 bereitgestellt.",
  "legal.terms.provider.body2": "Bei Fragen zu diesen Bedingungen kontaktieren Sie bitte <a href=\"mailto:admin@rentomax.be\">admin@rentomax.be</a>.",
  "legal.terms.scope.title": "2. Dienst und Geltungsbereich",
  "legal.terms.scope.body1": "Rentomax ist ein Online-Verwaltungstool fur Vermieter, selbststandige Vermieter, Unternehmen und andere Vermietungsbetriebe. Der Dienst hilft Nutzern dabei, Immobilien, Mieter, Vereinbarungen, Dokumente, Erinnerungen, Ereignisse und zugehorige Dossiers zu organisieren.",
  "legal.terms.scope.body2": "Rentomax ist kein Rechts-, Steuer-, Buchhaltungs- oder Compliance-Produkt und bietet weder Rechtsberatung noch automatische rechtliche Bewertungen.",
  "legal.terms.accounts.title": "3. Konten und Zugang",
  "legal.terms.accounts.item1": "Sie sind fur die Richtigkeit der von Ihnen angegebenen Kontoinformationen und fur die sichere Nutzung Ihres Kontos verantwortlich.",
  "legal.terms.accounts.item2": "Sie durfen Rentomax nur fur legitime administrative Zwecke innerhalb Ihrer eigenen Organisation, Tatigkeit oder Vermietungssituation nutzen.",
  "legal.terms.accounts.item3": "Sie bleiben fur alle uber Ihr Konto vorgenommenen Handlungen verantwortlich, sofern Sie uns nicht rechtzeitig uber einen Sicherheitsvorfall informieren.",
  "legal.terms.accounts.item4": "Wir konnen den Zugang verweigern, einschranken oder sperren, wenn dies verhaltnismassig erforderlich ist, um Betrug, Missbrauch, Sicherheitsvorfalle oder Vertragsverletzungen zu verhindern.",
  "legal.terms.acceptableUse.title": "4. Zulassige Nutzung",
  "legal.terms.acceptableUse.item1": "Sie durfen den Dienst nicht in einer Weise nutzen, die rechtswidrig, irrefuhrend, schadlich oder rechtsverletzend ist.",
  "legal.terms.acceptableUse.item2": "Sie durfen uber Rentomax keine Viren, Malware, nicht autorisierte Skripte oder anderen schadlichen Code hochladen oder verbreiten.",
  "legal.terms.acceptableUse.item3": "Sie durfen nicht versuchen, ohne Berechtigung auf den Dienst, die zugrunde liegenden Systeme oder Konten anderer Nutzer zuzugreifen, diese zu storen oder zu dekompilieren, soweit zwingendes Recht dies nicht erlaubt.",
  "legal.terms.acceptableUse.item4": "Sie durfen den Dienst nicht zur Verarbeitung personenbezogener Daten nutzen, wenn Ihnen dafur keine gultige Rechtsgrundlage oder erforderliche Erlaubnis vorliegt.",
  "legal.terms.customerData.title": "5. Ihre Daten und Inhalte",
  "legal.terms.customerData.body1": "Im Verhaltnis zwischen Ihnen und Ceustermans IT BV behalten Sie, soweit gesetzlich zulassig, das Eigentum an den Inhalten und Daten, die Sie in Rentomax eingeben oder hochladen.",
  "legal.terms.customerData.body2": "Sie sichern zu, dass Sie uber die erforderlichen Rechte und Erlaubnisse verfugen, um diese Daten in Rentomax zu speichern und zu verarbeiten. Sie sind fur die Rechtmassigkeit, Qualitat und Richtigkeit dieser Daten verantwortlich.",
  "legal.terms.billing.title": "6. Testphase, Abonnements und Zahlungen",
  "legal.terms.billing.item1": "Rentomax kann eine kostenlose Testphase anbieten. Fur die weitere Nutzung nach einer Testphase kann ein kostenpflichtiger Tarif erforderlich sein.",
  "legal.terms.billing.item2": "Kostenpflichtige Abonnements laufen fur das vereinbarte Abrechnungsintervall und verlangern sich automatisch, bis sie gekundigt werden.",
  "legal.terms.billing.item3": "Preise, Tarifgrenzen und enthaltener Speicher werden auf der Preisseite oder im Kontobereich angezeigt.",
  "legal.terms.billing.item4": "Zahlungen, Ruckerstattungen und Abonnementverarbeitung konnen uber externe Zahlungsanbieter abgewickelt werden.",
  "legal.terms.cancellation.title": "7. Kundigung, Anderungen und Widerrufsrechte",
  "legal.terms.cancellation.item1": "Sie konnen ein kostenpflichtiges Abonnement uber die verfugbaren Konto- oder Supportkanale kundigen. Eine ordentliche Kundigung stoppt zukunftige Verlangerungen zum Ende des laufenden bezahlten Zeitraums.",
  "legal.terms.cancellation.item2": "Upgrades konnen sofort wirksam werden. Downgrades oder Reduzierungen konnen je nach gewahltem Tarif und Intervall erst ab einem spateren bezahlten Zeitraum wirksam werden.",
  "legal.terms.cancellation.item3": "Wenn Sie als Verbraucher ein erstes kostenpflichtiges Abonnement abschliessen, kann ein gesetzliches Widerrufsrecht innerhalb von 14 Tagen nach Beginn dieses ersten kostenpflichtigen Abonnements ausgeubt werden. Wenn dieses Recht gilt, erstatten wir den gezahlten Betrag und stoppen zukunftige Verlangerungen.",
  "legal.terms.cancellation.item4": "Wir konnen Preise oder Tarifgrenzen fur zukunftige Zeitraume andern. Wenn eine solche Anderung Ihr bestehendes kostenpflichtiges Abonnement betrifft, werden wir versuchen, Sie vorab zu informieren.",
  "legal.terms.availability.title": "8. Verfugbarkeit und Anderungen des Dienstes",
  "legal.terms.availability.body1": "Wir bemuhen uns in angemessener Weise, Rentomax verfugbar, sicher und nutzbar zu halten, garantieren jedoch keine ununterbrochene oder fehlerfreie Verfugbarkeit.",
  "legal.terms.availability.body2": "Wir konnen den Dienst, Funktionen, die Benutzeroberflache, die technische Infrastruktur oder unterstutzte Integrationen von Zeit zu Zeit anpassen, verbessern, einschranken oder einstellen.",
  "legal.terms.ip.title": "9. Geistiges Eigentum",
  "legal.terms.ip.body": "Alle Rechte an Rentomax, einschliesslich Software, Marke, Design, Dokumentation und nicht von Nutzern bereitgestellten Inhalten, verbleiben bei Ceustermans IT BV oder deren Lizenzgebern. Diese Bedingungen gewahren Ihnen nur eine begrenzte, widerrufliche, nicht ausschliessliche Lizenz zur Nutzung des Dienstes fur die Dauer Ihrer rechtmassigen Nutzung.",
  "legal.terms.liability.title": "10. Gewahrleistungen und Haftung",
  "legal.terms.liability.body1": "Rentomax wird auf Grundlage angemessener professioneller Bemuhungen bereitgestellt. Soweit gesetzlich zulassig, sind stillschweigende Gewahrleistungen ausgeschlossen.",
  "legal.terms.liability.body2": "Ceustermans IT BV haftet nicht fur mittelbare Schaden, Folgeschaden, entgangenen Gewinn, entgangene Chancen, Datenverlust durch Handlungen des Nutzers oder Entscheidungen, die ausschliesslich auf Basis der Software-Ausgabe getroffen werden.",
  "legal.terms.liability.body3": "Nichts in diesen Bedingungen beschrankt eine Haftung, die nach zwingendem Recht nicht wirksam ausgeschlossen oder beschrankt werden kann.",
  "legal.terms.termination.title": "11. Beendigung",
  "legal.terms.termination.body": "Wir konnen Ihren Zugang aussetzen oder beenden, wenn Sie diese Bedingungen wesentlich verletzen, den Dienst missbrauchen, Sicherheitsrisiken verursachen oder Zahlungen offen lassen, soweit dies unter den Umstanden angemessen ist.",
  "legal.terms.law.title": "12. Anwendbares Recht und Streitigkeiten",
  "legal.terms.law.body": "Diese Bedingungen unterliegen belgischem Recht. Zustandig sind die Gerichte in Belgien, es sei denn, zwingendes Verbraucherrecht verlangt ein anderes zustandiges Gericht.",
  "richText.bold": "Fett",
  "richText.bulletList": "Aufzählung",
  "richText.numberedList": "Nummerierte Liste",
  "richText.link": "Link hinzufügen",
  "richText.linkPrompt": "Vollständigen Link eingeben",
  "landing.hero.title": "Alles für Ihre Mietobjekte,<br>an einem Ort.",
  "landing.hero.subtitle": "Rentomax ist die Verwaltungsplattform für Vermieter in Belgien und den Niederlanden. Behalten Sie Ihre Immobilien, Mieter, Dokumente und Fristen übersichtlich im Blick.",
  "landing.hero.primary": "Kostenlos starten",
  "landing.hero.secondary": "Funktionen entdecken",
  "landing.features.title": "Eine komplette Plattform für Ihre Vermietungsverwaltung",
  "landing.features.subtitle": "Von Ihrer ersten Immobilie bis zu einem größeren Portfolio: Verwalten Sie Gebäude, Einheiten, Mieter, Verträge, Dokumente, Nachverfolgung und Exporte an einem zentralen Ort.",
  "landing.feature.dashboard.title": "Dashboard und Portfolioübersicht",
  "landing.feature.dashboard.body": "Sehen Sie sofort, was Aufmerksamkeit braucht, mit Zusammenfassungen zu Belegung, offenen Aufgaben, bevorstehenden Enddaten und jüngsten Aktivitäten.",
  "landing.feature.portfolio.title": "Gebäude, Immobilien und Einheiten",
  "landing.feature.portfolio.body": "Verwalten Sie einzelne Immobilien oder ganze Gebäude mit mehreren Einheiten. Jede Einheit behält ihr eigenes Dossier, während gemeinsame Gebäudeinformationen zentral bleiben.",
  "landing.feature.tenants.title": "Mieter und Mietinteressenten",
  "landing.feature.tenants.body": "Speichern Sie Kontaktdaten, Statusangaben, Notizen und Historie pro Kontakt, damit Bewohnerwechsel und Nachverfolgung organisiert bleiben.",
  "landing.feature.documents.title": "Verträge und Dokumente",
  "landing.feature.documents.body": "Verknüpfen Sie Verträge, Bescheinigungen, Anhänge und andere Dateien mit der richtigen Immobilie, dem richtigen Gebäude, der richtigen Einheit oder dem richtigen Mieter. Alles bleibt in einem klaren Dossier leicht auffindbar.",
  "landing.feature.condition.title": "Zustandsberichte mit Fotos",
  "landing.feature.condition.body": "Erfassen Sie den Zustand Ihrer Immobilie Raum für Raum beim Ein- und Auszug. Arbeiten Sie mit Checklisten, Notizen und Fotos, die direkt dem richtigen Dossier zugeordnet sind.",
  "landing.feature.welcome.title": "Willkommensseite pro Mieter",
  "landing.feature.welcome.body": "Teilen Sie praktische Einzugs- und Nutzungsinformationen über einen persönlichen Link, den Sie für jeden neuen Mieter aktivieren und verwalten.",
  "landing.feature.issues.title": "Schadens- und Problemberichte",
  "landing.feature.issues.body": "Lassen Sie aktive Mieter Probleme oder Schäden mit Fotos melden, damit Sie jede Meldung pro Vertrag nachverfolgen können.",
  "landing.feature.payments.title": "Manuelle Zahlungsnachverfolgung",
  "landing.feature.payments.body": "Markieren Sie periodengenau, ob die Miete eingegangen ist, prüfen Sie die Historie und behalten Sie offene Monate ohne Bankintegrationen im Blick.",
  "landing.feature.calendar.title": "Erinnerungen, Ablauffristen und Kalender",
  "landing.feature.calendar.body": "Planen Sie Erinnerungen, verfolgen Sie Enddaten nach und sehen Sie alle wichtigen Termine Ihres Portfolios in einer gemeinsamen Kalenderübersicht.",
  "landing.feature.export.title": "PDF-Exporte für Dossiers",
  "landing.feature.export.body": "Stellen Sie einen Export pro Immobilie oder Mieter zusammen und bündeln Sie die passenden Abschnitte in einer PDF für interne Nutzung oder Übergabe.",
  "landing.cta.title": "Bereit, Ihre Mietobjekte besser zu verwalten?",
  "landing.cta.body": "Starten Sie noch heute kostenlos. Keine Kreditkarte erforderlich.",
  "landing.cta.button": "Konto erstellen",
  "landing.useCases.title": "Software für Vermieter, die einen klaren Überblick statt verstreuter Tools wollen",
  "landing.useCases.subtitle": "Rentomax bündelt Ihre tägliche Mietverwaltung in einem Arbeitsbereich, der von der ersten Immobilie bis zu einem größeren Portfolio mitwächst.",
  "landing.useCase.admin.title": "Vom Immobilienstatus bis zur Mieterakte an einem festen Ort",
  "landing.useCase.admin.body": "Nutzen Sie Rentomax als zentrale Software für Vermieter, um Immobilien, Einheiten, Mieter, Verträge und Notizen pro Akte zusammenzuhalten.",
  "landing.useCase.documents.title": "Weniger Suchen zwischen Dokumenten, Fotos und Ablaufdaten",
  "landing.useCase.documents.body": "Verknüpfen Sie Dokumente, Zustandsberichte, Fotos und Erinnerungen mit der richtigen Immobilie oder dem richtigen Mieter, damit die Nachverfolgung schneller läuft.",
  "landing.useCase.followup.title": "Mehr Kontrolle über Nachverfolgung, Onboarding und Planung",
  "landing.useCase.followup.body": "Arbeiten Sie mit Erinnerungen, Kalender, Onboarding und Exporten, um Ihre Mietverwaltung auch bei wachsendem Portfolio konsistent zu halten.",
  "landing.guides.title": "Entdecken Sie Rentomax über Funktionen, Preise und Hilfe",
  "landing.guides.subtitle": "Jede öffentliche Seite hilft Ihnen, einen anderen Teil der Plattform zu bewerten: was Sie verwalten, welcher Tarif passt und wie der tägliche Ablauf aussieht.",
  "landing.guides.features.title": "Sehen Sie, was Sie in Rentomax verwalten können",
  "landing.guides.features.body": "Entdecken Sie, wie die Plattform Immobilien, Mieter, Dokumente, Zustandsberichte, Erinnerungen und PDF-Exporte für Vermieter zusammenbringt.",
  "landing.guides.features.button": "Zu den Funktionen",
  "landing.guides.pricing.title": "Preise für Vermieter-Software vergleichen",
  "landing.guides.pricing.body": "Sehen Sie, welcher Tarif zu einer einzelnen Immobilie, einem wachsenden Portfolio oder einer professionelleren Vermietungsstruktur passt.",
  "landing.guides.pricing.button": "Preise ansehen",
  "landing.guides.help.title": "Lesen, wie Rentomax funktioniert",
  "landing.guides.help.body": "Nutzen Sie das Help Center für Onboarding, Gebäude mit Einheiten, Dokumenten-Nachverfolgung, Erinnerungen und Supportfragen.",
  "landing.guides.help.button": "Help Center öffnen",
  "login.page.title": "Anmelden",
  "login.heading": "Anmelden",
  "login.body": "Melden Sie sich an, um Ihre Immobilien, Mieter und Dokumente zu verwalten.",
  "login.footer": "Noch kein Konto? Durch die Anmeldung erstellen Sie automatisch ein Konto.",
  "pricing.hero.title": "Einfache, transparente Preise",
  "pricing.hero.subtitle": "Testen Sie Rentomax 14 Tage kostenlos. Keine Kreditkarte erforderlich.",
  "pricing.toggle.monthly": "Monatlich",
  "pricing.toggle.yearly": "Jährlich",
  "pricing.toggle.saveLabel": "2 Monate gratis",
  "pricing.trial.title": "Kostenlose Testphase",
  "pricing.trial.desc": "Entdecken Sie die Plattform 2 Wochen lang unverbindlich.",
  "pricing.starter.desc": "Ideal, wenn Sie eine Immobilie vermieten.",
  "pricing.pro.desc": "Für Vermieter mit mehreren Immobilien.",
  "pricing.business.desc": "Für professionelle Immobilienverwalter.",
  "pricing.custom.title": "Auf Maß",
  "pricing.custom.desc": "Mehr als 5 Immobilien? Wir bieten eine maßgeschneiderte Lösung.",
  "pricing.badge.popular": "Beliebt",
  "pricing.button.start": "Kostenlos starten",
  "pricing.button.getStarted": "Loslegen",
  "pricing.button.choosePro": "Pro wählen",
  "pricing.button.chooseBusiness": "Business wählen",
  "pricing.button.contactSales": "Kontaktieren Sie uns",
  "pricing.questions.title": "Noch Fragen?",
  "pricing.questions.body": "Kontaktieren Sie uns gerne. Wir helfen Ihnen gerne weiter.",
  "pricing.questions.button": "Kontaktieren Sie uns",
  "pricing.trial.period": "/ 14 Tage",
  "pricing.period.monthly": "/Monat inkl. MwSt.",
  "pricing.period.yearly": "/Jahr inkl. MwSt.",
  "pricing.feature.fullAccess": "Vollständiger Zugang zu allen Funktionen",
  "pricing.feature.documents": "Dokumentenablage",
  "pricing.feature.remindersTimeline": "Erinnerungen und Chronik",
  "pricing.feature.dashboard": "Dashboard",
  "pricing.feature.prioritySupport": "Prioritäts-Support",
  "pricing.feature.dedicatedSupport": "Dedicated Support",
  "pricing.starter.feature.properties": "1 Immobilie",
  "pricing.trial.feature.storage": "1 GB Speicher, gut für etwa 500 Dokumente oder Fotos",
  "pricing.starter.feature.storage": "1 GB Speicher, gut für etwa 500 Dokumente oder Fotos",
  "pricing.pro.feature.storage": "3 GB Speicher, gut für etwa 1.500 Dokumente oder Fotos",
  "pricing.business.feature.storage": "10 GB Speicher, gut für etwa 5.000 Dokumente oder Fotos",
  "pricing.custom.feature.storage": "Speicherplatz nach Maß",
  "pricing.storageEstimateNote": "Schätzung basierend auf einer durchschnittlichen Dateigröße von 2 MB pro Dokument oder Foto. PDFs sind oft kleiner, Fotos manchmal größer.",
  "pricing.fit.title": "Welcher Tarif passt zu Ihrer Mietverwaltung?",
  "pricing.fit.subtitle": "Nutzen Sie diese Orientierung, um schneller nach Anzahl der Immobilien, Umfang der Nachverfolgung und Größe Ihres Portfolios zu wählen.",
  "pricing.fit.starter.title": "Starter für die erste Immobilie oder ein kompaktes Portfolio",
  "pricing.fit.starter.body": "Wählen Sie Starter, wenn Sie vor allem eine Immobilie, den verknüpften Mieter, Dokumente und Erinnerungen an einem festen Ort verwalten möchten.",
  "pricing.fit.pro.title": "Pro für Vermieter mit mehreren Immobilien",
  "pricing.fit.pro.body": "Wählen Sie Pro, wenn Sie mehrere Akten gleichzeitig nachverfolgen und mehr Platz für Dokumente, Zustandsberichte und tägliche Abläufe brauchen.",
  "pricing.fit.business.title": "Business für eine größere oder professionellere Arbeitsweise",
  "pricing.fit.business.body": "Wählen Sie Business, wenn Sie Ihre Mietverwaltung über mehrere Immobilien hinweg strukturieren und mehr Speicher sowie Support benötigen.",
  "pricing.faq.title": "Häufige Fragen zu Preisen und Tarifen",
  "pricing.faq.intro": "Diese kurzen Antworten helfen Ihnen einzuschätzen, welcher Tarif am besten zu Ihren Immobilien, Dokumenten und täglichen Abläufen passt.",
  "pricing.faq.starter.question": "Für wen ist Starter am besten geeignet?",
  "pricing.faq.starter.answer": "Starter passt zu Vermietern, die eine erste Immobilie oder eine kleine Mietakte zentral verwalten wollen, ohne unnötige Komplexität.",
  "pricing.faq.scale.question": "Wann sollte ich lieber Pro oder Business wählen?",
  "pricing.faq.scale.answer": "Pro und Business passen besser, sobald Sie mehrere Immobilien verwalten, mehr Speicher brauchen und über mehrere Akten hinweg mehr Struktur wollen.",
  "pricing.faq.trial.question": "Kann ich erst kostenlos starten und später einen Tarif wählen?",
  "pricing.faq.trial.answer": "Ja. Sie können Rentomax 14 Tage kostenlos testen und erst danach entscheiden, welcher Tarif am besten zu Ihrem Portfolio und Ihrer Arbeitsweise passt.",
  "pricing.faq.contact.question": "Wo stelle ich Fragen zu Abonnements oder einem individuellen Angebot?",
  "pricing.faq.contact.answer": "Nutzen Sie das Help Center oder das Kontaktformular, um Abonnements, größere Portfolios oder eine maßgeschneiderte Einrichtung zu besprechen.",
  "pages.privacy.title": "Datenschutzerklarung",
  "pages.privacy.description": "Lesen Sie, wie Ceustermans IT BV personenbezogene Daten fur Rentomax verarbeitet, welche Rechte Sie haben und wie Sie uns zum Datenschutz kontaktieren konnen.",
  "pages.terms.title": "Nutzungsbedingungen",
  "pages.terms.description": "Lesen Sie die Rentomax-Bedingungen zu Kontoregeln, Abonnements, Kundigung, Haftung und Kontaktangaben.",
  "pricing.pro.feature.properties": "Bis zu 3 Immobilien",
  "pricing.business.feature.properties": "Bis zu 5 Immobilien",
  "pricing.custom.feature.properties": "Unbegrenzte Immobilien",
  "pricing.custom.feature.includes": "Alles von Business",
  "pricing.custom.feature.price": "Preis auf Anfrage",
  "pages.home.title": "Verwalten Sie Ihre Mietobjekte mit Leichtigkeit",
  "pages.pricing.title": "Preise",
  "pages.login.title": "Anmelden",
  "pages.dashboard.title": "Dashboard",
  "pages.calendar.title": "Kalender",
  "pages.properties.title": "Immobilien",
  "pages.damageReports.title": "Schadensmeldungen",
  "pages.propertyDetail.title": "Immobiliendetails",
  "pages.tenants.title": "Mieter",
  "pages.documents.title": "Dokumente",
  "pages.reminders.title": "Erinnerungen",
  "pages.contractors.title": "Auftragnehmer & Lieferanten",
  "pages.waitinglist.title": "Kandidaten und Warteliste",
  "tenantPage.title": "Mieter",
  "tenantPage.addButton": "Mieter hinzufugen",
  "tenantPage.empty": "Noch keine Mieter hinzugefugt.",
  "tenantPage.addFirst": "Ersten Mieter hinzufugen",
  "tenantPage.timeline": "Chronik",
  "tenantPage.loadError": "Fehler beim Laden.",
  "tenantPage.confirmDelete": "Mochten Sie diesen Mieter wirklich loschen?",
  "tenantPage.personalInfo": "Personliche Angaben",
  "tenantPage.noContact": "Keine Kontaktdaten",
  "tenantPage.agreementsTitle": "Mietvertrage",
  "tenantPage.noAgreements": "Keine Mietvertrage.",
  "tenantPage.tabs.info": "Daten",
  "tenantPage.tabs.payments": "Zahlungen",
  "tenantPage.tabs.timeline": "Chronik",
  "tenantPage.tabs.documents": "Dokumente",
  "tenantPage.tabs.placeDescriptions": "Zustandsbericht",
  "tenantPage.tabs.dossier": "Dossier",
  "tenantPage.tabs.actions": "Aktionen",
  "tenantPage.tabs.welcomePage": "Willkommensseite",
  "tenantPage.tabs.surveys": "Zufriedenheit",
  "tenantPage.moreActions": "Mehr Aktionen",
  "tenantPage.portalSectionTitle": "Rentomax-Konto",
  "tenantPage.portalSectionDescription": "Verknupfen Sie hier ein bestehendes Rentomax-Konto oder senden Sie die Einladung an die E-Mail-Adresse des Mieters.",
  "tenantPage.portalActionsUnavailable": "Keine weitere Aktion erforderlich",
  "tenantPage.portalLinkAction": "Rentomax-Konto verknupfen",
  "tenantPage.portalLinkConfirm": "Mochten Sie das bestehende Rentomax-Konto von {name} mit diesem Mieter verknupfen?",
  "tenantPage.portalLinkSuccess": "{name} ist jetzt mit Rentomax verknupft.",
  "tenantPage.portalLinkError": "Die Rentomax-Verknupfung konnte nicht erstellt werden.",
  "tenantPage.portalLinkUnavailable": "Fur diesen Mieter wurde kein verknupfbares Rentomax-Konto gefunden.",
  "tenantPage.portalInviteAction": "Rentomax-Konto einladen",
  "tenantPage.portalInviteResendAction": "Rentomax-Einladung erneut senden",
  "tenantPage.documentsTabDescription": "Verwalten Sie Mieterdokumente und laden Sie neue Dateien fur diesen Mieter hoch.",
  "tenantPage.placeDescriptionsTabDescription": "Offnen Sie die Zustandsberichte dieses Mieters in einem separaten Arbeitsbereich.",
  "tenantPage.placeDescriptionsTabAction": "Zustandsberichte offnen",
  "tenantPage.dossierTabDescription": "Exportieren Sie das Mieterdossier mit den Bereichen, die Sie einschliessen mochten.",
  "tenantPage.dossierTabAction": "Dossier exportieren",
  "tenantPage.portalInviteDialogTitle": "Mieter zu Rentomax einladen",
  "tenantPage.portalInviteDialogFreeNote": "In der E-Mail wird klargestellt, dass ein Mieterkonto bei Rentomax kostenlos ist und kostenlos bleibt.",
  "tenantPage.portalInviteDialogMessageLabel": "Personliche Nachricht in der E-Mail",
  "tenantPage.portalInviteDialogMessagePlaceholder": "Fugen Sie optional eine kurze personliche Nachricht hinzu.",
  "tenantPage.portalInviteSending": "Einladung wird gesendet...",
  "tenantPage.portalInviteSuccess": "Die Einladung wurde gesendet. Direkter Link:",
  "tenantPage.portalInviteError": "Die Einladung konnte nicht gesendet werden.",
  "tenantPage.portalInviteUnavailable": "Fur diesen Mieter kann derzeit keine Rentomax-Einladung gesendet werden.",
  "tenantPage.changeRent": "Miete andern",
  "tenantPage.noResults": "Keine Mieter fur diese Filter gefunden.",
  "tenantPage.filters.nameLabel": "Name",
  "tenantPage.filters.namePlaceholder": "Nach Name suchen",
  "tenantPage.filters.statusLabel": "Status",
  "tenantPage.filters.propertyLabel": "Immobilie",
  "tenantPage.filters.allStatuses": "Alle Status",
  "tenantPage.filters.allProperties": "Alle Immobilien",
  "tenantPage.filters.reset": "Filter zurucksetzen",
  "placeDescription.buttonShort": "Zustandsbericht",
  "placeDescription.title": "Digitale Zustandsberichte",
  "placeDescription.drawerHelp": "Verwalten Sie Einzugs- und Auszugsberichte pro Mieter mit strukturierter Checkliste und Fotos pro Punkt.",
  "placeDescription.add": "Zustandsbericht hinzufugen",
  "placeDescription.loadError": "Die Zustandsberichte konnten nicht geladen werden.",
  "placeDescription.empty": "Noch keine Zustandsberichte fur diesen Mieter.",
  "placeDescription.exportError": "Das PDF konnte nicht erstellt werden.",
  "placeDescription.confirmDelete": "Mochten Sie diesen Zustandsbericht wirklich loschen?",
  "placeDescription.confirmDeletePhoto": "Mochten Sie dieses Foto wirklich loschen?",
  "placeDescription.createUnavailable": "Erstellen Sie zuerst einen Mietvertrag, bevor Sie einen Zustandsbericht anlegen.",
  "placeDescription.templateLabel": "Checklisten-Vorlage",
  "placeDescription.titlePlaceholder": "Zum Beispiel: Zustandsbericht beim Einzug",
  "placeDescription.notesPlaceholder": "Allgemeine Notizen zum Zustand, zu Schlusseln, Zahlerstanden oder Absprachen...",
  "placeDescription.editorTitle": "Zustandsbericht bearbeiten",
  "placeDescription.itemCommentPlaceholder": "Kommentar zu diesem Checklistenpunkt",
  "placeDescription.addPhoto": "Foto hinzufugen",
  "placeDescription.noPhotos": "Diesem Punkt sind noch keine Fotos zugeordnet.",
  "placeDescription.kind.moveIn": "Einzug",
  "placeDescription.kind.moveOut": "Auszug",
  "placeDescription.condition.good": "Gut",
  "placeDescription.condition.needsAttention": "Beobachtungspunkt",
  "placeDescription.condition.damaged": "Beschadigt",
  "placeDescription.condition.notApplicable": "Nicht anwendbar",
  "placeDescription.stats.sections": "Bereiche",
  "placeDescription.stats.items": "Punkte",
  "placeDescription.stats.photos": "Fotos",
  "waitinglist.title": "Kandidaten und Warteliste",
  "waitinglist.subtitle": "Pipeline pro Objekt vom Kandidaten zum aktiven Mieter.",
  "waitinglist.addButton": "Kandidat hinzufugen",
  "waitinglist.addFirst": "Ersten Kandidaten hinzufugen",
  "waitinglist.noPropertiesTitle": "Keine Immobilien gefunden",
  "waitinglist.noPropertiesBody": "Fugen Sie zuerst eine Immobilie hinzu, bevor Sie Kandidaten verwalten.",
  "waitinglist.emptyTitle": "Noch keine Kandidaten fur dieses Objekt",
  "waitinglist.emptyBody": "Fugen Sie den ersten Mietkandidaten zur Pipeline hinzu.",
  "waitinglist.pipelineCount": "{count} Kandidaten in der Pipeline",
  "waitinglist.noCandidates": "Keine Kandidaten",
  "waitinglist.expiredSection": "Abgelaufen ({count})",
  "waitinglist.expiredContract": "Vertrag abgelaufen",
  "waitinglist.reactivateTitle": "Wieder als Kandidat setzen",
  "waitinglist.reactivateButton": "Wieder Kandidat",
  "waitinglist.rejectButton": "Ablehnen",
  "waitinglist.interestDate": "Interesse",
  "waitinglist.confirmDelete": "Mochten Sie diesen Kandidaten wirklich loschen?",
  "waitinglist.loadError": "Fehler beim Laden.",
  "waitinglist.status.candidate": "Kandidat",
  "waitinglist.status.selected": "Ausgewahlt",
  "waitinglist.status.rejected": "Abgelehnt",
  "waitinglist.status.activeTenant": "Aktiver Mieter",
  "pages.profile.title": "Mein Profil",
  "userMenu.profileHint": "Zu Mein Profil",
  "userMenu.accountMode": "Kontomodus wechseln",
  "userMenu.accountModeTenantHint": "Der Mietermodus ist aktiv. Offnen Sie Ihr Profil zum Wechseln.",
  "userMenu.accountModeLandlordHint": "Der Vermietermodus ist aktiv. Offnen Sie Ihr Profil zum Wechseln.",
  "userMenu.install": "App installieren",
  "userMenu.installHint": "Rentomax auf Laptop oder Smartphone hinzufugen",
  "pwa.installIosInstructions": "Offnen Sie Teilen und wahlen Sie 'Zum Home-Bildschirm', um Rentomax zu installieren.",
  "pwa.installManualInstructions": "Offnen Sie das Browsermenu und wahlen Sie 'App installieren' oder 'Zum Home-Bildschirm hinzufugen'.",
  "pwa.installed": "Rentomax wurde zu Ihrem Gerat hinzugefugt.",
  "pages.tenantActive.title": "Aktive Mietverhältnisse",
  "pages.tenantUpcoming.title": "Zukünftige Mietverhältnisse",
  "pages.tenantApplications.title": "Bewerbungen",
  "pages.tenantHistory.title": "Vergangene Mietverhältnisse",
  "pages.onboarding.title": "Willkommen bei Rentomax",
  "pages.help.title": "Hilfecenter",
  "pages.help.description": "Finden Sie Antworten auf Ihre Fragen zu Rentomax.",
  "help.hero.title": "Wie können wir helfen?",
  "help.hero.subtitle": "Stellen Sie Ihre Frage über das Kontaktformular unten.",
  "help.resources.title": "Schneller zum richtigen Rentomax-Thema",
  "help.resources.subtitle": "Nutzen Sie diese schnellen Einstiege, wenn Sie vor allem Funktionen erkunden, Preise vergleichen oder direkt eine Supportfrage stellen möchten.",
  "help.resources.features.title": "Sehen Sie, was Sie in Rentomax verwalten",
  "help.resources.features.body": "Gehen Sie zurück zur Startseite für einen Überblick über Immobilienverwaltung, Mieter, Dokumente, Erinnerungen, Zustandsberichte und Exporte.",
  "help.resources.features.button": "Zu den Funktionen",
  "help.resources.pricing.title": "Preispläne vergleichen",
  "help.resources.pricing.body": "Öffnen Sie die Preisseite, wenn Sie sehen möchten, welcher Tarif zu einer ersten Immobilie, mehreren Immobilien oder einer größeren Vermietungsstruktur passt.",
  "help.resources.pricing.button": "Preise ansehen",
  "help.resources.contact.title": "Direkt eine Supportfrage stellen",
  "help.resources.contact.body": "Gehen Sie direkt zum Kontaktformular, wenn Sie Hilfe bei Onboarding, Akten, Dokumenten oder Kontofragen brauchen.",
  "help.resources.contact.button": "Formular öffnen",
  "help.faq.title": "Häufig gestellte Fragen",
  "help.faq.intro": "Wählen Sie ein Thema und öffnen Sie nur die Antwort, die Sie brauchen.",
  "help.faq.navLabel": "FAQ-Kategorien",
  "help.faq.questionCount": "{count} Fragen",
  "help.faq.categories.gettingStarted.title": "Einstieg in Rentomax",
  "help.faq.categories.gettingStarted.description": "Grundeinrichtung, erste Erfassung und eine praktische Reihenfolge für den Start.",
  "help.faq.categories.propertiesTenants.title": "Objekte und Mieter",
  "help.faq.categories.propertiesTenants.description": "Wie Sie Ihr Portfolio, Interessenten, Mieter und Zustandsbeschreibungen organisieren.",
  "help.faq.categories.agreementsDocuments.title": "Verträge und Dokumente",
  "help.faq.categories.agreementsDocuments.description": "Was pro Vertrag gespeichert werden sollte, wie Sie Dokumente nachverfolgen und was exportierbar ist.",
  "help.faq.categories.planningPayments.title": "Planung und Nachverfolgung",
  "help.faq.categories.planningPayments.description": "Erinnerungen, Ereignisse, Kalendernutzung und manuelle Zahlungsübersicht.",
  "help.faq.categories.dataSupport.title": "Arbeitsweise und Support",
  "help.faq.categories.dataSupport.description": "Praktische Hinweise, um Daten nutzbar zu halten und schnell Hilfe zu bekommen.",
  "help.faq.questions.setup.question": "Wie starte ich am besten mit Rentomax?",
  "help.faq.questions.setup.answer": "Beginnen Sie mit Ihren Profildaten, fügen Sie danach Ihre Objekte hinzu und geben Sie jedem Objekt einen klaren Status. Anschließend legen Sie Mieter oder Interessenten an, verknüpfen die relevanten Mietverträge und laden die wichtigsten Dokumente hoch. Zum Schluss erstellen Sie Erinnerungen und Ereignisse, damit Ihre Nachverfolgung sofort im Dashboard und Kalender sichtbar wird.",
  "help.faq.questions.import.question": "Kann ich bestehende Daten übernehmen, statt alles neu einzugeben?",
  "help.faq.questions.import.answer": "Ja. Nutzen Sie Onboarding und CSV-Import, um bestehende Objekte, Mieter oder andere administrative Basisdaten schneller zu übernehmen. Prüfen Sie nach einem Import immer Statuswerte, Verknüpfungen und Daten, damit Ihre Übersicht vom ersten Tag an verlässlich bleibt.",
  "help.faq.questions.overview.question": "Wie halte ich meine Übersicht von Anfang an brauchbar?",
  "help.faq.questions.overview.answer": "Arbeiten Sie konsequent mit festen Statuswerten, vollständigen Namen und klaren Notizen. Erfassen Sie nicht nur Mindestangaben, sondern auch wichtige Termine, Dokumentenverknüpfungen und interne Hinweise. Je einheitlicher die Eingabe, desto nützlicher werden Filter, Dashboards und Zeitachsen.",
  "help.faq.questions.countries.question": "Kann ich Rentomax für Objekte in verschiedenen Ländern nutzen?",
  "help.faq.questions.countries.answer": "Ja. Rentomax ist für Mietverwaltung über mehrere Länder hinweg gedacht. Sie organisieren damit Objekte, Mieter, Verträge, Dokumente und Nachverfolgung. Welche lokalen Regelungen oder rechtlichen Anforderungen für Ihre Situation gelten, müssen Sie jedoch selbst prüfen, da Rentomax keine Rechtsberatung bietet.",
  "help.faq.questions.propertySetup.question": "Wie richte ich ein Objekt am besten ein?",
  "help.faq.questions.propertySetup.answer": "Legen Sie für jedes Objekt eine vollständige Akte mit Adressdaten, Status, internen Notizen und allen Dokumenten an, die Sie später benötigen könnten. Nutzen Sie Statuswerte, um sofort zu sehen, ob ein Objekt verfügbar, vermietet oder in Nachverfolgung ist. Das beschleunigt Filtern, Planen und Auswerten deutlich.",
  "help.faq.questions.buildingUnits.question": "Wie arbeite ich in Rentomax mit Gebäuden und Einheiten?",
  "help.faq.questions.buildingUnits.answer": "Sie können ein Gebäude mit mehreren Einheiten verwalten, während jede Einheit ihre eigene Akte behält. Gemeinsame Gebäudeinformationen und Dokumente bleiben gleichzeitig zentral verfügbar.",
  "help.faq.questions.tenantTracking.question": "Wie verwalte ich Interessenten und aktive Mieter übersichtlich?",
  "help.faq.questions.tenantTracking.answer": "Trennen Sie Interessenten und aktive Mieter über ihren Status und verknüpfen Sie sie mit dem richtigen Objekt. Ergänzen Sie Kontaktdaten, Notizen und relevante Nachverfolgungspunkte sofort. So sehen Sie auf einen Blick, wer noch geprüft wird, wer ausgewählt wurde und welcher Mieter bereits aktiv mit einem Vertrag verknüpft ist.",
  "help.faq.questions.welcomePage.question": "Wofür nutze ich die Tenant Welcome Page?",
  "help.faq.questions.welcomePage.answer": "Mit der Welcome Page bündeln Sie praktische Informationen zu einem Mieter oder einer Akte an einem Ort. Das können Einzugsabsprachen, nützliche Dokumente, gemeinsame Referenzen oder Informationen sein, die Sie intern bereithalten möchten. So starten Sie eine neue Akte strukturiert, ohne Kontext zu verteilen.",
  "help.faq.questions.issueReporting.question": "Wie verfolge ich Problem- und Schadensmeldungen von Mietern nach?",
  "help.faq.questions.issueReporting.answer": "Aktive Mieter können Probleme oder Schäden mit Fotos melden. Sie sehen diese Meldungen anschließend in Ihrer Nachverfolgung pro Vertrag oder Objekt.",
  "help.faq.questions.placeDescriptions.question": "Wie nutze ich Zustandsbeschreibungen, Notizen und Fotos am besten?",
  "help.faq.questions.placeDescriptions.answer": "Verwenden Sie Zustandsbeschreibungen, um den Zustand eines Objekts oder Raums klar festzuhalten, ergänzt durch Fotos und kurze Notizen. Arbeiten Sie strukturiert pro Raum oder Bestandteil, damit Sie später schneller etwas wiederfinden. Ziel ist eine vollständige Verwaltungsakte, keine rechtliche Bewertung.",
  "help.faq.questions.agreementInfo.question": "Welche Informationen gehören zu einem Mietvertrag in Rentomax?",
  "help.faq.questions.agreementInfo.answer": "Speichern Sie pro Vertrag den zugehörigen Mieter, das verknüpfte Objekt, die Laufzeit, wichtige Start- und Enddaten, interne Hinweise und unterstützende Dokumente. Ergänzen Sie außerdem Erinnerungen für Verlängerungen, Nachverfolgung oder Dokumente, die später erneuert werden müssen. So bleibt jeder Vertrag mit dem restlichen Dossier verbunden.",
  "help.faq.questions.documentFollowUp.question": "Wie verfolge ich Dokumente und Ablaufdaten effizient?",
  "help.faq.questions.documentFollowUp.answer": "Laden Sie Dokumente direkt beim richtigen Objekt, Mieter oder Vertrag hoch und legen Sie Erinnerungen für relevante End- oder Prüftermine an. Verwenden Sie klare Dateinamen und Notizen, damit Sie später wissen, was jedes Dokument enthält. So wird die Ablaufüberwachung Teil Ihrer täglichen Übersicht statt separater Sucharbeit.",
  "help.faq.questions.pdfDossier.question": "Wann ist der PDF-Export sinnvoll?",
  "help.faq.questions.pdfDossier.answer": "Der PDF-Export ist sinnvoll, wenn Sie eine Akte teilen, intern archivieren oder eine Momentaufnahme der vorhandenen Verwaltung erzeugen möchten. Stellen Sie vorher sicher, dass verknüpfte Daten, Dokumente und Notizen aktuell sind. Dann erhalten Sie eine brauchbare Übersicht, ohne mehrere Ansichten manuell zusammenzuführen.",
  "help.faq.questions.productBoundary.question": "Bietet Rentomax rechtliche, steuerliche oder Compliance-Beratung?",
  "help.faq.questions.productBoundary.answer": "Nein. Rentomax ist ein Verwaltungstool, um Informationen zu organisieren, nachzuverfolgen und zentral zu speichern. Es hilft Ihnen bei Übersicht und Timing, aber nicht bei Rechtsberatung, steuerlicher Einordnung, gesetzlicher Konformität oder automatischen Berechnungen wie Indexierung.",
  "help.faq.questions.remindersEvents.question": "Was ist der Unterschied zwischen Erinnerungen und Ereignissen?",
  "help.faq.questions.remindersEvents.answer": "Nutzen Sie Erinnerungen für Punkte, die aktiv nachverfolgt werden müssen, etwa ein Dokumentenablaufdatum, einen Vertragsmeilenstein oder eine interne Aufgabe. Nutzen Sie Ereignisse für wichtige Daten oder Vorkommnisse, die Sie in Zeitachse und Kalender festhalten möchten. Zusammen geben sie Ihnen sowohl Aufgaben als auch Verlauf.",
  "help.faq.questions.manualPayments.question": "Wie funktioniert die manuelle Erfassung von Mietzahlungen?",
  "help.faq.questions.manualPayments.answer": "Rentomax ermöglicht es Ihnen, Zahlungsstatus pro Akte manuell zu erfassen und nachzuverfolgen. Das ist nützlich, um zu sehen, was bezahlt wurde, was noch offen ist oder was weiter verfolgt wird. Das System hat keine Bankanbindung und gleicht Zahlungen nicht automatisch ab; nutzen Sie es daher als Verwaltungsübersicht neben Ihrer eigenen finanziellen Kontrolle.",
  "help.faq.questions.dashboardCalendar.question": "Wie nutze ich Dashboard und Kalender am effizientesten?",
  "help.faq.questions.dashboardCalendar.answer": "Verwenden Sie das Dashboard als täglichen Startpunkt: Prüfen Sie offene Nachverfolgung, anstehende Fristen und aktuelle Aktivitäten. Nutzen Sie den Kalender, um objekt- und aktenübergreifend vorauszuplanen. Wenn Sie täglich aus diesen beiden Übersichten arbeiten, entgehen Ihnen Fristen oder offene Punkte deutlich seltener.",
  "help.faq.questions.recurringWorkflow.question": "Wie sieht eine gute Routine für wiederkehrende Nachverfolgung aus?",
  "help.faq.questions.recurringWorkflow.answer": "Arbeiten Sie mit kurzen festen Kontrollen: neue Dokumente aktualisieren, Erinnerungen auf künftige Fristen setzen, Ereignisse direkt nach ihrem Eintritt erfassen und Statuswerte sofort anpassen. So bleibt Ihre Verwaltung aktuell, ohne dass später große Korrekturrunden nötig werden.",
  "help.faq.questions.dataQuality.question": "Wie halte ich meine Daten sauber und zuverlässig?",
  "help.faq.questions.dataQuality.answer": "Legen Sie eine feste Arbeitsweise für Namen, Statuswerte, Dokumenttitel und Notizen fest. Vermeiden Sie doppelte Akten und aktualisieren Sie Änderungen sofort, statt sie später erinnern zu müssen. Eine gepflegte Akte pro Objekt und Mieter macht Suchen, Filtern und Exportieren deutlich schneller.",
  "help.faq.questions.newOnboarding.question": "Wie füge ich ein neues Objekt oder einen neuen Mieter schnell hinzu, ohne etwas zu vergessen?",
  "help.faq.questions.newOnboarding.answer": "Arbeiten Sie mit einer festen Checkliste: Basisdaten eintragen, Status wählen, Kontaktdaten ergänzen, Dokumente verknüpfen, Vertragsdaten erfassen und Erinnerungen anlegen. Wenn Sie diese Reihenfolge beibehalten, bauen Sie jede neue Akte gleich auf und halten die Übersicht einheitlich.",
  "help.faq.questions.timelineUsage.question": "Warum ist die Zeitachse im Arbeitsalltag wichtig?",
  "help.faq.questions.timelineUsage.answer": "Die Zeitachse hilft Ihnen zu sehen, was in einer Akte bereits passiert ist und welche Nachverfolgung daraus entstanden ist. Wenn Sie Ereignisse, Notizen und Änderungen konsequent erfassen, verlieren Sie weniger Kontext, wenn Sie später zurückblicken oder eine Akte erneut aufnehmen.",
  "help.faq.questions.profileManagement.question": "Wo verwalte ich mein Vermieterprofil und meine Kontoeinstellungen?",
  "help.faq.questions.profileManagement.answer": "Nutzen Sie Mein Profil, um Profildaten, Kontomodus und Kontozugriffe zu verwalten. So bleiben Ihr Arbeitskontext und Ihre Kontoeinstellungen an einem festen Ort gebündelt.",
  "help.faq.questions.helpContact.question": "Was mache ich, wenn ich in der FAQ trotzdem keine Antwort finde?",
  "help.faq.questions.helpContact.answer": "Nutzen Sie dann das Kontaktformular unten auf dieser Seite. Beschreiben Sie kurz, um welches Objekt, welchen Mieter oder welchen Bildschirm es geht, und nennen Sie, was Sie bereits versucht haben. Mit diesem Kontext kann der Support schneller eine brauchbare Antwort geben.",
  "help.contact.title": "Senden Sie uns eine Nachricht",
  "help.success.title": "Nachricht gesendet!",
  "help.success.body": "Wir melden uns so schnell wie möglich bei Ihnen.",
  "help.success.reset": "Weitere Nachricht senden",
  "help.form.name": "Name",
  "help.form.namePlaceholder": "Max Mustermann",
  "help.form.emailPlaceholder": "max@beispiel.de",
  "help.form.email": "E-Mail-Adresse",
  "help.form.subject": "Betreff",
  "help.form.subjectPlaceholder": "Worum geht es bei Ihrer Frage?",
  "help.form.message": "Nachricht",
  "help.form.messagePlaceholder": "Beschreiben Sie Ihre Frage oder Ihr Problem...",
  "help.form.sending": "Wird gesendet...",
  "help.form.submit": "Nachricht senden",
  "help.form.error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
  "help.form.networkError": "Keine Verbindung möglich. Überprüfen Sie Ihre Internetverbindung.",
  "dashboard.activeTenants": "Aktive Mieter",
  "dashboard.upcomingDeadlines": "Bevorstehende Fristen",
  "dashboard.propertyStatuses": "Objekte nach Status",
  "dashboard.buildingOccupancy": "Belegung pro Gebaude",
  "dashboard.buildingOccupancyMeta": "{occupied} von {total} Einheiten vermietet",
  "dashboard.noUpcomingDeadlines": "Keine bevorstehenden Fristen",
  "dashboard.recentEvents": "Aktuelle Ereignisse",
  "dashboard.noRecentEvents": "Keine aktuellen Ereignisse",
  "dashboard.viewAllReminders": "Alle Erinnerungen anzeigen",
  "dashboard.viewTenants": "Mieter anzeigen",
  "calendar.title": "Integrierter Kalender",
  "calendar.subtitle": "Alle anstehenden Daten aus Erinnerungen, Dokumenten, Verträgen und Ereignissen in einer schreibgeschützten Übersicht.",
  "calendar.todayButton": "Heute",
  "calendar.viewDay": "Tag",
  "calendar.viewWeek": "Woche",
  "calendar.filter.all": "Alle",
  "calendar.highlights.title": "Braucht Aufmerksamkeit",
  "calendar.highlights.subtitle": "Die dringendsten Elemente im gewählten Zeitraum.",
  "calendar.quickAction.property": "Objekt öffnen",
  "calendar.quickAction.tenant": "Mieter öffnen",
  "calendar.loadError": "Fehler beim Laden des Kalenders",
  "calendar.empty": "Keine Einträge in diesem Zeitraum.",
  "calendar.summary.total": "Gesamt",
  "calendar.summary.reminders": "Erinnerungen",
  "calendar.summary.documents": "Dokumentabläufe",
  "calendar.summary.agreements": "Vertragsenden",
  "calendar.summary.events": "Ereignisse",
  "calendar.source.reminder": "Erinnerung",
  "calendar.source.documentExpiry": "Dokument",
  "calendar.source.agreementEnd": "Vertrag",
  "calendar.source.timelineEvent": "Ereignis",
  "calendar.item.agreementEndTitle": "Vertrag endet",
  "calendar.item.recurring": "Wiederkehrend",
  "property.loadError": "Fehler beim Laden der Immobilien.",
  "property.deleteError": "Die Immobilie konnte nicht geloescht werden.",
  "property.cardView": "Kartenansicht",
  "property.listView": "Listenansicht",
  "property.import": "CSV importieren",
  "property.importTitle": "Immobilien per CSV importieren",
  "property.importDescription": "Verwenden Sie dieselbe CSV-Vorlage, um bestehende Immobilien und Mieter direkt in die Plattform zu ubernehmen.",
  "property.importTemplateLink": "template.csv herunterladen",
  "property.importFileLabel": "CSV-Datei",
  "property.importButton": "Import starten",
  "property.importHint": "Wir erstellen nur die Immobilien und Mieter, die innerhalb Ihres aktuellen Abolimits liegen. Wenn die Datei Ihr Limit uberschreitet, wird der Import ohne neue Eintrage gestoppt.",
  "property.importSuccess": "{propertyCount} Immobilien und {tenantCount} Mieter importiert.",
  "property.importFileRequired": "Wahlen Sie zuerst die ausgefullte CSV-Datei aus.",
  "property.importError": "Der Import ist fehlgeschlagen. Versuchen Sie es erneut mit der Vorlagendatei.",
  "property.importRowError": "Zeile {rowNumber} enthalt ungueltige Daten.",
  "property.add": "Immobilie hinzufügen",
  "property.addFirst": "Erste Immobilie hinzufügen",
  "property.empty": "Noch keine Immobilien hinzugefügt.",
  "property.rent": "Miete",
  "property.perMonth": "/Monat",
  "property.tenantSingular": "Mieter",
  "property.tenantPlural": "Mieter",
  "property.unitSingular": "Einheit",
  "property.unitPlural": "Einheiten",
  "property.units.title": "Einheiten",
  "property.documentSingular": "Dokument",
  "property.documentPlural": "Dokumente",
  "property.status.rented": "Vermietet",
  "property.status.vacant": "Leer",
  "property.status.underRenovation": "In Renovierung",
  "property.status.forSale": "Zu verkaufen",
  "property.type.apartment": "Wohnung",
  "property.type.house": "Haus",
  "property.type.studio": "Studio",
  "property.type.commercial": "Gewerbe",
  "property.type.garage": "Garage",
  "property.type.other": "Sonstiges",
  "property.details.backToOverview": "Zur Immobilienubersicht zuruck",
  "property.details.pageTitle": "Immobiliendetails",
  "property.details.pageSubtitle": "Verwalten Sie Mieter, Dokumente und Nachverfolgung fur diese Immobilie auf einer eigenen Seite.",
  "property.details.missingSelection": "Wahlen Sie zuerst eine Immobilie aus der Ubersicht.",
  "property.details.loadError": "Fehler beim Laden der Immobiliendetails.",
  "property.rentHistory.title": "Mietverlauf",
  "property.rentHistory.subtitle": "Chronologischer Überblick über die bereits erfassten Miethöhen und Vertragszeiträume dieser Immobilie.",
  "property.rentHistory.empty": "Für diese Immobilie ist noch kein Mietverlauf verfügbar.",
  "property.rentHistory.records": "Einträge",
  "property.rentHistory.latestRent": "Letzte Miete",
  "property.rentHistory.ongoing": "laufender Vertrag",
  "property.occupancy.title": "Belegungsübersicht",
  "property.occupancy.subtitle": "Visuelle Zeitleiste von vermieteten Zeiträumen, Leerstand und Mieterwechseln auf Basis vorhandener Vertragsdaten.",
  "property.occupancy.empty": "Für diese Immobilie ist noch keine Vertragshistorie verfügbar.",
  "property.occupancy.contractCount": "Verträge",
  "property.occupancy.currentlyOccupied": "Derzeit vermietet",
  "property.occupancy.currentlyVacant": "Derzeit leer",
  "property.occupancy.summary.rented": "Vermietet",
  "property.occupancy.summary.vacant": "Leerstand",
  "property.occupancy.summary.averageLease": "Durchschnittliche Mietdauer",
  "property.occupancy.summary.switches": "Mieterwechsel",
  "property.occupancy.legend.occupied": "Vermietet",
  "property.occupancy.legend.vacant": "Leerstand",
  "property.occupancy.legend.switch": "Wechselzeitpunkt",
  "property.occupancy.switchesTitle": "Mieterwechsel",
  "property.occupancy.switchesSubtitle": "Wechsel zwischen verschiedenen Mietern für diese Immobilie.",
  "property.occupancy.noSwitches": "Aus den vorhandenen Verträgen wurden noch keine Mieterwechsel erfasst.",
  "property.occupancy.switchDirect": "Direkter Wechsel",
  "property.occupancy.switchAfterVacancy": "Nach {{duration}} Leerstand",
  "property.occupancy.vacancyLabel": "Leerstand",
  "property.occupancy.occupiedLabel": "Vermietet",
  "property.occupancy.until": "bis",
  "property.occupancy.duration.none": "0 Tage",
  "property.occupancy.duration.days": "{{count}} Tage",
  "property.occupancy.duration.months": "{{count}} Mon",
  "property.occupancy.duration.monthsAndDays": "{{months}} Mon {{days}} Tage",
  "property.gallery.title": "Objektgalerie",
  "property.gallery.helper": "Nutzen Sie diese Fotos, wenn Sie das Objekt sp?ter hervorheben m?chten. Dieser Speicher z?hlt ebenfalls zu Ihrem Limit.",
  "property.gallery.upload": "Fotos hinzuf?gen",
  "property.gallery.empty": "Noch keine Galeriefotos f?r dieses Objekt.",
  "property.gallery.confirmDelete": "Dieses Galeriefoto l?schen?",
  "property.gallery.previewAlt": "Galeriefoto: {{fileName}}",
  "property.gallery.openPreview": "Galeriefoto {{fileName}} öffnen",
  "property.gallery.lightboxTitle": "Galeriefoto vergrößern",
  "property.gallery.closePreview": "Fotovorschau schließen",
  "property.gallery.previous": "Vorheriges Foto",
  "property.gallery.next": "Nächstes Foto",
  "property.gallery.position": "Foto {{current}} von {{total}}",
  "property.publicPage.tabTitle": "Offentliche Seite",
  "property.publicPage.title": "Offentlicher Objektlink",
  "property.publicPage.helper": "Erstellen Sie fur dieses Objekt eine offentliche Seite, die Sie mit Mietinteressenten teilen konnen. Der Link zeigt Adresse, Typ, Beschreibung und Galeriefotos.",
  "property.publicPage.status.notConfigured": "Noch nicht eingerichtet",
  "property.publicPage.status.inactive": "Link deaktiviert",
  "property.publicPage.status.active": "Link aktiv",
  "property.publicPage.status.expired": "Link abgelaufen",
  "property.publicPage.publicLink": "Offentlicher Link",
  "property.publicPage.linkUnavailable": "Speichern Sie zuerst die Einstellungen, um einen offentlichen Link zu erzeugen.",
  "property.publicPage.isActiveLabel": "Offentlichen Link erreichbar machen",
  "property.publicPage.isActiveHint": "Besucher ohne Konto konnen diese Seite offnen, solange der Link aktiv ist.",
  "property.publicPage.expiresAt": "Erreichbar bis",
  "property.publicPage.expiresAtHint": "Optional. Leer lassen, wenn der Link immer erreichbar bleiben soll.",
  "property.publicPage.alwaysAvailable": "Immer erreichbar",
  "property.publicPage.save": "Einstellungen speichern",
  "property.publicPage.saved": "Offentlicher Objektlink gespeichert.",
  "property.publicPage.copySuccess": "Offentlicher Link kopiert.",
  "property.publicPage.copyError": "Kopieren des offentlichen Links fehlgeschlagen.",
  "property.publicPage.clearExpiry": "Leeren",
  "property.publicPage.updatedAt": "Letzte Aktualisierung",
  "property.publicPage.previewTitle": "Was Besucher sehen werden",
  "property.publicPage.previewDescription": "Die offentliche Seite nutzt die Basisinfos des Objekts und die Fotos aus Ihrer Galerie.",
  "property.publicPage.previewAddress": "Adresse",
  "property.publicPage.previewType": "Typ",
  "property.publicPage.previewStatus": "Status",
  "property.publicPage.previewPhotos": "Galeriefotos",
  "property.publicPage.previewNoDescription": "Fugen Sie eine Objektbeschreibung hinzu, um auf der offentlichen Seite mehr Kontext zu zeigen.",
  "property.publicPage.loadError": "Die offentlichen Objekteinstellungen konnten nicht geladen werden.",
  "property.radar.title": "Ablaufdatum-Radar",
  "property.radar.subtitle": "Visueller Überblick über Dokumente, Verträge und offene Erinnerungen in den nächsten 12 Monaten.",
  "property.radar.empty": "Keine Ablaufdaten oder offene Erinnerungen in den nächsten 12 Monaten gefunden.",
  "property.radar.contractEnds": "Vertrag endet",
  "property.radar.upcoming": "Später",
  "property.radar.urgent": "Jetzt dringend",
  "property.radar.noUrgent": "Keine dringenden Ablaufdaten in den nächsten 30 Tagen.",
  "property.radar.timeline": "12 Monate",
  "property.radar.moreItems": "weitere Einträge",
  "document.upload": "Dokument hochladen",
  "property.turnovers.title": "Mieterwechsel",
  "property.turnovers.subtitle": "Verfolgen Sie Auszug und Einzug Schritt fur Schritt und halten Sie jeden erledigten Schritt in der Zeitleiste fest.",
  "property.turnovers.addButton": "Checkliste starten",
  "property.turnovers.empty": "Noch keine Mieterwechsel-Checklisten fur diese Immobilie.",
  "property.turnovers.loadError": "Fehler beim Laden der Mieterwechsel-Checklisten.",
  "property.turnovers.createError": "Fehler beim Erstellen der Mieterwechsel-Checkliste.",
  "property.turnovers.updateError": "Fehler beim Aktualisieren der Mieterwechsel-Checkliste.",
  "property.turnovers.deleteError": "Fehler beim Loschen der Mieterwechsel-Checkliste.",
  "property.turnovers.confirmDelete": "Mochten Sie diese Mieterwechsel-Checkliste wirklich loschen?",
  "property.turnovers.createTitle": "Mieterwechsel starten",
  "property.turnovers.titlePlaceholder": "Zum Beispiel: Wechsel Wohnung 2A",
  "property.turnovers.completedShort": "erledigt",
  "property.turnovers.completedAt": "Abgehakt am",
  "property.turnovers.exitPhase": "Auszug",
  "property.turnovers.entryPhase": "Einzug",
  "property.turnovers.exitHelp": "Aufgaben fur den ausziehenden Mieter.",
  "property.turnovers.entryHelp": "Aufgaben fur den neuen Mieter.",
  "property.turnovers.exitMissingAgreement": "Verknupfen Sie zuerst den ausziehenden Mieter, bevor Sie Auszugsschritte abhaken.",
  "property.turnovers.entryMissingAgreement": "Verknupfen Sie zuerst den neuen Mieter, bevor Sie Einzugsschritte abhaken.",
  "property.turnovers.outgoingTenantLabel": "Ausziehender Mieter",
  "property.turnovers.incomingTenantLabel": "Neuer Mieter",
  "property.turnovers.noOutgoingTenant": "Noch nicht verknupft",
  "property.turnovers.noIncomingTenant": "Noch nicht verknupft",
  "property.turnovers.openPlaceDescription": "Zustandsprotokoll offnen",
  "property.turnovers.step.exitKeysReturned": "Schlussel zuruckgegeben",
  "property.turnovers.step.exitMeterReadingsRecorded": "Endzahler notiert",
  "property.turnovers.step.exitPlaceDescriptionCompleted": "Auszugsprotokoll erstellt",
  "property.turnovers.step.exitDepositStatusRecorded": "Kautionsstatus notiert",
  "property.turnovers.step.exitDomicileHandled": "Wohnsitz umgemeldet",
  "property.turnovers.step.entryKeysHandedOver": "Schlussel ubergeben",
  "property.turnovers.step.entryMeterReadingsRecorded": "Anfangszahler notiert",
  "property.turnovers.step.entryPlaceDescriptionCompleted": "Einzugsprotokoll erstellt",
  "property.turnovers.step.entryDepositStatusRecorded": "Kautionsstatus notiert",
  "property.turnovers.step.entryHouseRulesShared": "Mieter uber Hausregeln informiert",
  "timeline.turnover.exitKeysReturned": "Mieterwechsel: Schlussel zuruckgegeben",
  "timeline.turnover.exitMeterReadingsRecorded": "Mieterwechsel: Endzahler notiert",
  "timeline.turnover.exitPlaceDescriptionCompleted": "Mieterwechsel: Auszugsprotokoll erstellt",
  "timeline.turnover.exitDepositStatusRecorded": "Mieterwechsel: Kautionsstatus beim Auszug notiert",
  "timeline.turnover.exitDomicileHandled": "Mieterwechsel: Ummeldung erledigt",
  "timeline.turnover.entryKeysHandedOver": "Mieterwechsel: Schlussel ubergeben",
  "timeline.turnover.entryMeterReadingsRecorded": "Mieterwechsel: Anfangszahler notiert",
  "timeline.turnover.entryPlaceDescriptionCompleted": "Mieterwechsel: Einzugsprotokoll erstellt",
  "timeline.turnover.entryDepositStatusRecorded": "Mieterwechsel: Kautionsstatus beim Einzug notiert",
  "timeline.turnover.entryHouseRulesShared": "Mieterwechsel: Mieter uber Hausregeln informiert",
  "document.type.inspection": "Prüfung",
  "document.type.insurance": "Versicherung",
  "document.type.invoice": "Rechnung",
  "document.type.photo": "Foto",
  "document.type.other": "Sonstiges",
  "document.title": "Dokumente",
  "document.loadError": "Fehler beim Laden.",
  "document.all": "Alle",
  "document.empty": "Noch keine Dokumente hochgeladen.",
  "document.emptyFiltered": "Keine Dokumente vom Typ \"{type}\".",
  "document.uploadFirst": "Erstes Dokument hochladen",
  "document.linkProperty": "Mit Immobilie verknüpfen",
  "document.linkTenant": "Mit Mieter verknüpfen",
  "document.tagsPlaceholder": "z. B. Prüfung, jährlich",
  "document.confirmDelete": "Möchten Sie dieses Dokument wirklich löschen?",
  "document.expired": "Abgelaufen",
  "document.expiringSoon": "Bald",
  "document.share": "Teilen",
  "document.shareTitle": "Dokumentlink teilen",
  "document.shareLink": "Öffentlicher Link",
  "document.shareExpires": "Dieser Link bleibt bis {date} verfügbar.",
  "document.shareCopied": "Link kopiert.",
  "document.shareError": "Link konnte nicht erstellt werden.",
  "reminder.add": "Erinnerung hinzufügen",
  "document.uploadError": "Das Dokument konnte nicht hochgeladen werden.",
  "document.storageTitle": "Speicherplatz",
  "document.storageHelp": "Ihr Dokumenten- und Fotospeicher folgt dem Limit Ihres aktuellen Abonnements.",
  "document.storageLimitExceeded": "Ihr Speicherlimit ist erreicht. Erweitern Sie Ihr Abonnement, um mehr Dateien hochzuladen.",
  "document.storageUpgradeButton": "Upgrade-Optionen ansehen",
  "document.storageSelectionTooLarge": "Diese Datei ist etwa {fileSize} groß, aber Sie haben nur noch {remaining} Speicher frei.",
  "reminder.title": "Erinnerungen",
  "reminder.loadError": "Fehler beim Laden.",
  "reminder.overdueAlert": "{count} überfällige Erinnerung{suffix} - Aktion erforderlich.",
  "reminder.emptyOpen": "Keine offenen Erinnerungen.",
  "reminder.emptyCompleted": "Keine abgeschlossenen Erinnerungen.",
  "reminder.emptyAll": "Noch keine Erinnerungen erstellt.",
  "reminder.complete": "Abschließen",
  "reminder.new": "Neue Erinnerung",
  "reminder.linkProperty": "Mit Immobilie verknüpfen",
  "reminder.titlePlaceholder": "z. B. EPC erneuern",
  "reminder.confirmDelete": "Möchten Sie diese Erinnerung wirklich löschen?",
  "reminder.recurrence": "Wiederholung",
  "reminder.noRecurrence": "Einmalig",
  "reminder.recurring": "Wiederkehrend",
  "reminder.recurrenceHint": "Lassen Sie die Anzahl leer fur eine einmalige Erinnerung.",
  "reminder.recurrenceSummaryOneTime": "Diese Erinnerung wird einmalig erstellt.",
  "reminder.recurrenceSummaryValue": "Diese Erinnerung wiederholt sich: {recurrence}.",
  "reminder.recurrenceDateSummaryMissingDeadline": "Wahlen Sie erst eine Frist, um das geplante Datum zu sehen.",
  "reminder.recurrenceDateSummaryOneTime": "Diese Erinnerung findet statt am: {date}.",
  "reminder.recurrenceDateSummaryRecurring": "Die nachste Erinnerung nach dieser Frist ist am: {date}.",
  "reminder.recurrenceValueLabel": "Alle",
  "reminder.recurrenceValuePlaceholder": "Anzahl",
  "reminder.recurrenceUnit": "Wiederholungstyp",
  "reminder.recurrenceUnitDaySingle": "Tag",
  "reminder.recurrenceUnitDay": "Tage",
  "reminder.recurrenceUnitMonthSingle": "Monat",
  "reminder.recurrenceUnitMonth": "Monate",
  "reminder.recurrenceUnitYearSingle": "Jahr",
  "reminder.recurrenceUnitYear": "Jahre",
  "reminder.recurrenceEveryDay": "Jeden Tag",
  "reminder.recurrenceEveryMonth": "Jeden Monat",
  "reminder.recurrenceEveryYear": "Jedes Jahr",
  "reminder.recurrenceEveryNDays": "Alle {count} Tage",
  "reminder.recurrenceEveryNMonths": "Alle {count} Monate",
  "reminder.recurrenceEveryNYears": "Alle {count} Jahre",
  "contractor.title": "Auftragnehmer & Lieferanten",
  "contractor.subtitle": "Halte verlässliche Kontakte für Wartung, Reparaturen, Besichtigungen und praktische Nachverfolgung bereit.",
  "contractor.add": "Auftragnehmer hinzufügen",
  "contractor.new": "Neuer Auftragnehmer",
  "contractor.edit": "Auftragnehmer bearbeiten",
  "contractor.empty": "Noch keine Auftragnehmer oder Lieferanten hinzugefügt.",
  "contractor.emptyFiltered": "Keine Auftragnehmer passen zu den aktuellen Filtern.",
  "contractor.loadError": "Fehler beim Laden der Auftragnehmer.",
  "contractor.confirmDelete": "Möchten Sie diesen Auftragnehmer wirklich löschen?",
  "contractor.deleteError": "Der Auftragnehmer konnte nicht geloescht werden.",
  "contractor.trade": "Gewerk / Dienst",
  "contractor.filter.searchLabel": "Suchen",
  "contractor.filter.searchPlaceholder": "Nach Name, Gewerk, Notiz, E-Mail oder Telefon suchen",
  "contractor.filter.tradeLabel": "Gewerk",
  "contractor.filter.allTrades": "Alle Gewerke",
  "contractor.stats.total": "Kontakte",
  "contractor.stats.email": "Mit E-Mail",
  "contractor.stats.phone": "Mit Telefon",
  "contractor.namePlaceholder": "z. B. Jan Vermeersch",
  "contractor.tradePlaceholder": "z. B. Klempner, Elektriker, …",
  "contractor.phoneNumberPlaceholder": "z. B. +32 475 12 34 56",
  "contractor.emailPlaceholder": "z. B. info@firma.de",
  "contractor.notesPlaceholder": "z. B. Schnell verfügbar, gutes Preis-Leistungs-Verhältnis",
  "profile.notLoggedIn": "Sie sind nicht angemeldet.",
  "profile.paymentMethods": "Zahlungsmittel",
  "profile.invoices": "Rechnungen",
  "profile.paymentMethodsSoon": "Zahlungsmittel sind bald verfügbar.",
  "profile.invoicesSoon": "Rechnungen sind bald verfügbar.",
  "profile.loading": "Profil wird geladen...",
  "profile.name": "Name",
  "profile.providerName": "Name Ihres Anmeldeanbieters",
  "profile.displayNameTitle": "Anzeigename",
  "profile.displayNameHelp": "Verwenden Sie Ihren Vor- und Nachnamen.",
  "profile.customDisplayName": "Name",
  "profile.loginProvider": "Angemeldet über",
  "profile.addressDetails": "Adressdaten",
  "profile.addressHelp": "Diese Daten werden für Ihr Vermieterprofil verwendet.",
  "profile.accountType": "Kontotyp",
  "profile.accountType.private": "Privat",
  "profile.accountType.business": "Geschäftlich",
  "profile.companyName": "Firmenname",
  "profile.vatNumber": "USt-Nummer",
  "profile.street": "Straße",
  "profile.houseNumber": "Hausnummer",
  "profile.postalCode": "Postleitzahl",
  "profile.city": "Stadt",
  "profile.country": "Land",
  "profile.countryPlaceholder": "EU-Land waehlen",
  "profile.billingAddress": "Rechnungsadresse",
  "profile.billingHelp": "Optional. Nur ausfüllen, wenn sie von Ihrer normalen Adresse abweicht.",
  "profile.saveButton": "Profil speichern",
  "profile.saved": "Profil gespeichert.",
  "profile.loadError": "Profil konnte nicht geladen werden.",
  "profile.saveError": "Profil konnte nicht gespeichert werden.",
  "onboarding.displayNameHelp": "Verwenden Sie Ihren Vor- und Nachnamen, um Ihr Konto einzurichten.",
  "onboarding.csvTitle": "Bestehende Immobilien importieren",
  "onboarding.csvDescription": "Verwenden Sie die CSV-Vorlage, um bestehende Immobilien und Mieter in einem Schritt zu ubernehmen. Jede Zeile enthalt einen Namen, eine Adresse, einen Mietpreis und ein Startdatum.",
  "onboarding.csvTemplateLink": "template.csv herunterladen",
  "onboarding.csvFileLabel": "CSV auswahlen",
  "onboarding.csvImportButton": "CSV importieren",
  "onboarding.csvHint": "Nach einem erfolgreichen Import uberspringen wir den manuellen Immobilien- und Mieterschritt und fahren direkt mit dem Onboarding fort.",
  "billing.loading": "Abonnementdaten werden geladen...",
  "billing.subscriptionTab": "Abonnement",
  "billing.invoicesTab": "Rechnungen",
  "billing.checkoutSuccess": "Ihr Abonnement wurde erfolgreich aktiviert.",
  "billing.checkoutProcessing": "Ihre Zahlung wurde empfangen und wird noch verarbeitet.",
  "billing.processingEyebrow": "Zahlung in Bearbeitung",
  "billing.processingTitle": "Wir aktualisieren Ihr Abonnement",
  "billing.processingBody": "Ihre Zahlung war erfolgreich. Rentomax wartet noch, bis die Zahlungsabwicklung und Synchronisierung vollstandig abgeschlossen sind.",
  "billing.processingHint": "Diese Seite wird automatisch aktualisiert, sobald Ihr Abonnement aktiv ist oder Ihre Anderung verarbeitet wurde.",
  "billing.checkoutCancelled": "Der Checkout wurde abgebrochen.",
  "billing.checkoutError": "Checkout konnte nicht gestartet werden.",
  "billing.resumeCheckoutTitle": "Abonnement wird vorbereitet",
  "billing.resumeCheckoutBody": "Einen Moment. Wir leiten Sie direkt zu Ihrem Abonnement oder zum Checkout weiter.",
  "billing.portalError": "Das Kundenportal konnte nicht geöffnet werden.",
  "billing.portalLoading": "Portal wird geöffnet...",
  "billing.noSubscription": "Sie haben noch kein aktives Abonnement.",
  "billing.noSubscriptionTitle": "Kein aktives Abonnement",
  "billing.choosePlan": "Abonnement wählen",
  "billing.choosePlanHelp": "Wählen Sie einen Plan und einen Abrechnungszeitraum, um fortzufahren.",
  "billing.currentPlan": "Aktuelles Abonnement",
  "billing.currentTrialPlan": "Testphase",
  "billing.manageInAppHelp": "K?ndigung, Upgrade und Downgrade verwalten Sie hier direkt in Rentomax.",
  "billing.manageHelp": "Kündigung, Upgrade, Downgrade und Zahlungsdaten werden über das Kundenportal des Zahlungsanbieters verwaltet.",
  "billing.planLabel": "Plan",
  "billing.intervalLabel": "Abrechnung",
  "billing.statusLabel": "Status",
  "billing.adminTitle": "Administratorzugang",
  "billing.adminBody": "Ihr Konto hat Administratorrechte. Für diese Rolle ist kein Abonnement erforderlich.",
  "billing.adminBadge": "Kein Abonnement erforderlich",
  "billing.trialTitle": "Kostenlose Testphase",
  "billing.trialBody": "Sie nutzen Rentomax vorübergehend mit denselben Limits wie im Starter-Abo.",
  "billing.trialChoosePlanHelp": "Ihre Testphase läuft noch. Wählen Sie bereits ein Abo, um Rentomax nach der Testphase weiter zu nutzen.",
  "billing.trialStartedOn": "Gestartet am",
  "billing.trialEndsOn": "Endet am",
  "billing.trialDayRemaining": "Tag verbleibend",
  "billing.trialDaysRemaining": "{count} Tage verbleibend",
  "billing.propertyLimitSingular": "1 Objekt",
  "billing.propertyLimitPlural": "{count} Objekte",
  "billing.renewsOn": "Verlängert sich am",
  "billing.endsOn": "Endet am",
  "billing.creditBalance": "Guthaben",
  "billing.storageUsed": "Verbraucht",
  "billing.storageAvailable": "Speicherlimit",
  "billing.storageRemaining": "Verbleibend",
  "billing.storagePlanFeature": "{storage} Speicher, gut für etwa {count} Dokumente oder Fotos",
  "billing.cancelScheduled": "Ihr Abonnement endet am Ende der aktuellen Periode.",
  "billing.manageSubscription": "Abonnement verwalten",
  "billing.comparePlans": "Pläne vergleichen",
  "billing.invoiceHistory": "Rechnungshistorie",
  "billing.changePlan": "Abonnement ?ndern",
  "billing.changePlanHelp": "Upgrades werden direkt nach der Zahlung aktiviert. Downgrades werden f?r die n?chste Abrechnungsperiode eingeplant.",
  "billing.changeTerms.title": "Änderungen an Ihrem Abonnement",
  "billing.changeTerms.linkLabel": "Klicken Sie hier, um die Bedingungen für Änderungen zu lesen",
  "billing.changeTerms.consentLabel": "Ich habe die Bedingungen für Änderungen gelesen und stimme ihnen zu, bevor ich mein Abonnement ändere.",
  "consent.eyebrow": "Datenschutz",
  "consent.title": "Wahlen Sie, wie Rentomax Speicher auf diesem Gerat verwendet",
  "consent.description": "Rentomax verwendet Cookies und lokalen Speicher fur Sprachwahl, Sitzungssicherheit und eine reibungslose Nutzung auf offentlichen und angemeldeten Seiten.",
  "consent.actions.necessary": "Nur notwendig",
  "consent.actions.all": "Alles akzeptieren",
  "consent.saved.pending": "Ihre Auswahl wird auf diesem Gerat gespeichert, sobald Sie eine Option wahlen.",
  "consent.saved.necessary": "Ihre Auswahl fur nur notwendigen Speicher wurde auf diesem Gerat gespeichert.",
  "consent.saved.all": "Ihre Auswahl zum Zulassen aller Speicherarten wurde auf diesem Gerat gespeichert.",
  "billing.changeTerms.validationError": "Bitte bestätigen Sie zuerst, dass Sie die Bedingungen für Änderungen gelesen haben, bevor Sie ein Abonnement auswählen.",
  "billing.changeTerms.intro": "Wenn Sie Ihr Abonnement ändern, gelten die folgenden Verrechnungsregeln für den Rest der bereits bezahlten Abrechnungsperiode.",
  "billing.changeTerms.downgrade": "Ein Downgrade auf einen niedrigeren Tarif oder ein günstigeres Modell wird erst am Ende Ihrer aktuellen bezahlten Abrechnungsperiode wirksam. Ihr aktuelles Abonnement bleibt bis dahin aktiv und bereits gezahlte Beträge werden während der laufenden Periode nicht erstattet.",
  "billing.changeTerms.upgrade": "Ein Upgrade auf einen höheren Tarif oder ein anderes Modell wird sofort wirksam. Der Restwert Ihrer aktuellen Periode wird anteilig als Guthaben auf kommende Zahlungen angerechnet.",
  "billing.cancelSubscription": "Abonnement k?ndigen",
  "billing.cancelConfirm": "M?chten Sie Ihr Abonnement wirklich k?ndigen?",
  "billing.coolingOffTrialStartedTitle": "Ihre kostenlose Testphase hat begonnen",
  "billing.coolingOffTrialStartedBody": "Ihr Abonnement wurde gekuendigt und Sie wechseln jetzt in eine kostenlose 14-taegige Testphase.",
  "billing.coolingOffProfileOnlyTitle": "Ihr Abonnement wurde gekuendigt",
  "billing.coolingOffProfileOnlyBody": "Ihr Abonnement wurde gekuendigt. Ihnen steht keine kostenlose Testphase mehr zur Verfuegung und Sie haben jetzt nur noch Zugriff auf diese Profilseite.",
  "billing.subscriptionUpdated": "Ihre Abonnement?nderung wurde verarbeitet.",
  "billing.subscriptionUpdatedImmediate": "Ihr Abonnement wurde sofort aktualisiert.",
  "billing.subscriptionUpdatedScheduled": "Ihre Abonnement?nderung wurde f?r die n?chste Abrechnungsperiode eingeplant.",
  "billing.subscriptionUpdateError": "Ihr Abonnement konnte nicht ge?ndert werden.",
  "billing.subscriptionCancelled": "Ihr Abonnement wurde gek?ndigt.",
  "billing.subscriptionCancelError": "Ihr Abonnement konnte nicht gek?ndigt werden.",
  "billing.subscriptionActionLoading": "Wird verarbeitet...",
  "billing.currentSelection": "Aktuelle Auswahl",
  "billing.pendingChangeTitle": "Geplante ?nderung",
  "billing.pendingChangeBody": "Ihr Abonnement wechselt am {date} zu {plan} ({interval}).",
  "billing.pendingChangeBodyAfterPayment": "Ihr Abonnement wechselt zu {plan} ({interval}), sobald Ihre Zahlung best?tigt ist.",
  "billing.invoiceHelp": "Öffnen Sie hier Ihre Rechnungen, sobald sie verfügbar sind.",
  "billing.noInvoices": "Noch keine Rechnungen verfügbar.",
  "billing.invoiceLabel": "Rechnung",
  "billing.creditNoteLabel": "Gutschrift",
  "billing.invoiceFallbackTitle": "Rechnung",
  "billing.viewInvoice": "Rechnung ansehen",
  "billing.manageExistingSubscription": "Sie haben bereits ein aktives Abonnement. Verwalten Sie Upgrades und Downgrades in Ihrem Profil.",
  "billing.status.active": "Aktiv",
  "billing.status.trialing": "Testphase",
  "billing.status.pastDue": "Überfällig",
  "billing.status.canceled": "Gekündigt",
  "billing.status.unpaid": "Unbezahlt",
  "billing.status.incomplete": "Unvollständig",
  "billing.status.incompleteExpired": "Abgelaufen",
  "billing.status.paid": "Bezahlt",
  "billing.status.open": "Offen",
  "billing.status.pending": "In Bearbeitung",
  "billing.status.failed": "Fehlgeschlagen",
  "billing.status.expired": "Abgelaufen",
  "billing.status.draft": "Entwurf",
  "billing.status.void": "Storniert",
  "trialNotice.title": "Ihre kostenlose Testphase hat begonnen",
  "trialNotice.subtitle": "Sie können Rentomax jetzt 14 Tage kostenlos nutzen.",
  "trialNotice.body": "Während der Testphase haben Sie dieselben Möglichkeiten wie im Starter-Abo. Sie können später in Ihrem Profil ein Abo auswählen.",
  "trialNotice.confirm": "Verstanden",
  "property.limit.title": "Sie haben das Limit Ihres Abonnements erreicht",
  "property.limit.error": "Ihr Abonnement erlaubt keine weiteren Immobilien.",
  "property.limit.description.single": "Ihr aktuelles Abonnement erlaubt maximal {count} Immobilie.",
  "property.limit.description.multi": "Ihr aktuelles Abonnement erlaubt maximal {count} Immobilien.",
  "property.limit.description.singleWithPlan": "Ihr aktuelles Abonnement erlaubt maximal {count} Immobilie. Wechseln Sie zu {plan}, um mehr Immobilien hinzuzufugen.",
  "property.limit.description.multiWithPlan": "Ihr aktuelles Abonnement erlaubt maximal {count} Immobilien. Wechseln Sie zu {plan}, um mehr Immobilien hinzuzufugen.",
  "property.limit.upgradeButton": "Upgrade-Optionen ansehen",
  "event.moveIn": "Einzug",
  "event.moveOut": "Auszug",
  "event.damage": "Schaden",
  "event.inspection": "Inspektion",
  "event.indexation": "Indexierung",
  "event.propertyStatusChange": "Objektstatus",
  "event.remark": "Anmerkung",
  "confirm.title": "Bestätigung",
  "timeline.add": "Ereignis hinzufügen",
  "timeline.empty": "Noch keine Ereignisse erfasst.",
  "timeline.newEvent": "Neues Ereignis",
  "timeline.titlePlaceholder": "Beschreiben Sie das Ereignis kurz",
  "timeline.descriptionPlaceholder": "Optionale zusätzliche Details...",
  "timeline.saving": "Wird gespeichert...",
  "timeline.loadError": "Fehler beim Laden der Chronik.",
  "tenantPayments.sectionTitle": "Mietzahlungen",
  "tenantPayments.empty": "Es sind noch keine Mietverträge mit Zahlungsmonaten verfügbar.",
  "tenantPayments.unavailable": "Fehler beim Laden des Zahlungsprotokolls.",
  "tenantPayments.modalTitle": "Mietzahlung nachverfolgen",
  "tenantPayments.statusLabel": "Status",
  "tenantPayments.clearStatus": "Nicht ausgefüllt",
  "tenantPayments.paidOn": "Bezahlt am",
  "tenantPayments.note": "Notiz",
  "tenantPayments.notePlaceholder": "Zum Beispiel: 3 Tage verspätet oder teilweise bezahlt",
  "tenantPayments.saveError": "Das Speichern der Mietzahlung ist fehlgeschlagen.",
  "tenantPayments.status.paid": "Bezahlt",
  "tenantPayments.status.unpaid": "Nicht bezahlt",
  "tenantPayments.status.unmarked": "Offen",
  "nav.admin": "Admin",
  "pages.admin.title": "Admin",
  "pages.admin.description": "Benutzer und Anwendungsfehler in Rentomax verwalten.",
  "admin.loadError": "Fehler beim Laden der Benutzer.",
  "admin.accessDenied": "Zugriff verweigert. Administratorrechte erforderlich.",
  "admin.subtitle": "Benutzer verwalten und protokollierte Anwendungsfehler pruefen.",
  "admin.tab.users": "Benutzer",
  "admin.tab.plans": "Abonnements",
  "admin.tab.invoices": "Rechnungen",
  "admin.tab.creditNotes": "Gutschriften",
  "admin.tab.revenue": "Umsatz",
  "admin.tab.errors": "Fehler",
  "admin.billingPlans.title": "Abonnements verwalten",
  "admin.billingPlans.subtitle": "Passen Sie Preis, Immobilienlimit und Speicherlimit pro Abonnement an. Neue Abonnements konnen hier nicht hinzugefugt oder entfernt werden.",
  "admin.billingPlans.monthlyPrice": "Monatspreis (EUR)",
  "admin.billingPlans.yearlyPrice": "Jahrespreis (EUR)",
  "admin.billingPlans.priceExcludingVat": "exkl. 21 % MwSt.: {amount}",
  "admin.billingPlans.propertyLimit": "Immobilienlimit",
  "admin.billingPlans.storageLimitGb": "Speicherlimit (GB)",
  "admin.billingPlans.save": "Speichern",
  "admin.billingPlans.loadError": "Die Abonnementkonfiguration konnte nicht geladen werden.",
  "admin.billingPlans.saveError": "Die Abonnementkonfiguration konnte nicht gespeichert werden.",
  "admin.platformReset.openButton": "Plattform zurucksetzen",
  "admin.platformReset.dialogTitle": "Plattform zurucksetzen",
  "admin.platformReset.dialogSubtitle": "Loschen Sie alle Plattformdaten ausser dem Konto admin@rentomax.be und allen Daten, die mit diesem Konto verknupft sind.",
  "admin.platformReset.warningTitle": "Warnung: Dieser Reset setzt die Plattform in einen sauberen Ausgangszustand zuruck.",
  "admin.platformReset.warningIntro": "Nach der Bestatigung werden alle anderen Benutzer, Immobilien, Mieter, Abonnements, Rechnungen, Logs und verknupften Storage-Dateien dauerhaft geloscht.",
  "admin.platformReset.consequenceData": "Alle Datenbankdaten anderer Konten werden aus allen verknupften Tabellen entfernt.",
  "admin.platformReset.consequenceFiles": "Alle verknupften Dokumente, Fotos, Rechnungen und Gutschriften im Storage werden ebenfalls geloscht.",
  "admin.platformReset.consequencePreserved": "Nur admin@rentomax.be und alle mit diesem Konto verknupften Daten bleiben erhalten.",
  "admin.platformReset.consequenceIrreversible": "Nach der Bestatigung kann dieser Reset nicht mehr ruckgangig gemacht werden.",
  "admin.platformReset.confirmationLabel": "Geben Sie rentomax zur Bestatigung ein",
  "admin.platformReset.confirmationPlaceholder": "rentomax",
  "admin.platformReset.confirmationHelp": "Die Bestatigungsschaltflache wird erst aktiv, wenn Sie exakt rentomax eingeben.",
  "admin.platformReset.confirmationMismatch": "Geben Sie exakt rentomax ein, um den Reset zu bestatigen.",
  "admin.platformReset.confirmLabel": "Plattform zurucksetzen",
  "admin.platformReset.resetError": "Die Plattform konnte nicht zuruckgesetzt werden.",
  "admin.newUserAccess.sectionTitle": "Zugang fur neue Benutzer",
  "admin.newUserAccess.sectionDescription": "Steuern Sie, ob neue Konten sich noch registrieren durfen. Bestehende Konten behalten ihren Zugang.",
  "admin.newUserAccess.enabled": "Neue Benutzer zugelassen",
  "admin.newUserAccess.disabled": "Neue Benutzer blockiert",
  "admin.newUserAccess.toggleLabel": "Ein/aus",
  "admin.newUserAccess.saveError": "Die Einstellung fur neue Benutzer konnte nicht gespeichert werden.",
  "admin.googleLogin.sectionTitle": "Google-Anmeldung",
  "admin.googleLogin.sectionDescription": "Steuern Sie, ob Besucher sich weiterhin uber Google anmelden oder ein Konto erstellen durfen. Die Schaltflache auf der Login-Seite folgt dieser Einstellung sofort.",
  "admin.googleLogin.enabled": "Google-Anmeldung aktiv",
  "admin.googleLogin.disabled": "Google-Anmeldung deaktiviert",
  "admin.googleLogin.toggleLabel": "Ein/aus",
  "admin.googleLogin.saveError": "Die Google-Anmeldeeinstellung konnte nicht gespeichert werden.",
  "admin.microsoftLogin.sectionTitle": "Microsoft-Anmeldung",
  "admin.microsoftLogin.sectionDescription": "Steuern Sie, ob Besucher sich weiterhin uber Microsoft anmelden oder ein Konto erstellen durfen. Die Schaltflache auf der Login-Seite folgt dieser Einstellung sofort.",
  "admin.microsoftLogin.enabled": "Microsoft-Anmeldung aktiv",
  "admin.microsoftLogin.disabled": "Microsoft-Anmeldung deaktiviert",
  "admin.microsoftLogin.toggleLabel": "Ein/aus",
  "admin.microsoftLogin.saveError": "Die Microsoft-Anmeldeeinstellung konnte nicht gespeichert werden.",
  "admin.userCount": "{count} Benutzer",
  "admin.col.provider": "Anbieter",
  "admin.col.effectiveDisplayName": "Name",
  "admin.col.email": "E-Mail",
  "admin.col.id": "Id",
  "admin.col.externalId": "ExternalId",
  "admin.col.createdAt": "Erstellt",
  "admin.col.lastLoggedIn": "Zuletzt angemeldet",
  "admin.col.onboarding": "Onboarding",
  "admin.col.business": "Geschäft",
  "admin.col.role": "Rolle",
  "admin.completed": "Abgeschlossen",
  "admin.notCompleted": "Nicht abgeschlossen",
  "admin.yes": "Ja",
  "admin.no": "Nein",
  "admin.role.admin": "Admin",
  "admin.role.landlord": "Vermieter",
  "admin.viewDetails": "Details anzeigen",
  "admin.filter.email": "E-Mail",
  "admin.filter.name": "Name",
  "admin.filter.namePlaceholder": "Nach Name suchen",
  "admin.filter.emailPlaceholder": "Nach E-Mail suchen",
  "admin.filter.id": "Id",
  "admin.filter.idPlaceholder": "Nach Id oder ExternalId suchen",
  "admin.filter.business": "Geschäft",
  "admin.filter.onboarding": "Onboarding",
  "admin.filter.all": "Alle",
  "admin.filter.apply": "Filter anwenden",
  "admin.filter.reset": "Zurücksetzen",
  "admin.noResults": "Keine Benutzer gefunden.",
  "admin.billingDocuments.count": "{count} Dokumente",
  "admin.billingDocuments.col.number": "Nummer",
  "admin.billingDocuments.col.firstName": "Vorname",
  "admin.billingDocuments.col.lastName": "Nachname",
  "admin.billingDocuments.col.amount": "Betrag",
  "admin.billingDocuments.col.date": "Datum",
  "admin.invoices.loadError": "Fehler beim Laden der Rechnungen.",
  "admin.invoices.title": "Plattformrechnungen",
  "admin.invoices.subtitle": "Ubersicht aller Rechnungen innerhalb der Plattform mit Download pro Zeile.",
  "admin.invoices.empty": "Keine Rechnungen gefunden.",
  "admin.creditNotes.loadError": "Fehler beim Laden der Gutschriften.",
  "admin.creditNotes.title": "Plattformgutschriften",
  "admin.creditNotes.subtitle": "Ubersicht aller Gutschriften innerhalb der Plattform mit Download pro Zeile.",
  "admin.creditNotes.empty": "Keine Gutschriften gefunden.",
  "admin.revenue.loadError": "Fehler beim Laden der Umsatzübersicht.",
  "admin.revenue.title": "Realisierter Umsatz pro Kalenderjahr",
  "admin.revenue.subtitle": "Nettoübersicht bezahlter Rechnungen und Gutschriften ab dem Kalenderjahr 2026.",
  "admin.revenue.empty": "Keine Umsatzdaten gefunden.",
  "admin.revenue.totalLabel": "Gesamt seit 2026",
  "admin.revenue.yearsTrackedLabel": "Kalenderjahre in der Übersicht",
  "admin.revenue.col.year": "Jahr",
  "admin.revenue.col.amount": "Umsatz",
  "admin.revenue.col.invoices": "Rechnungen",
  "admin.revenue.col.creditNotes": "Gutschriften",
  "admin.errors.loadError": "Fehler beim Laden der Anwendungsfehler.",
  "admin.errors.count": "{count} Fehler",
  "admin.errors.noResults": "Keine Anwendungsfehler gefunden.",
  "admin.errors.viewDetails": "Fehlerdetails anzeigen",
  "admin.errors.delete": "Fehler loschen",
  "admin.errors.confirmDelete": "Mochten Sie diesen Anwendungsfehler wirklich loschen?",
  "admin.errors.deleteSuccess": "Anwendungsfehler geloscht.",
  "admin.errors.deleteError": "Der Anwendungsfehler konnte nicht geloscht werden.",
  "admin.errors.filter.functionName": "Funktion",
  "admin.errors.filter.functionNamePlaceholder": "Nach Funktionsname suchen",
  "admin.errors.filter.path": "Pfad",
  "admin.errors.filter.pathPlaceholder": "Nach Endpoint-Pfad suchen",
  "admin.errors.filter.method": "Methode",
  "admin.errors.filter.userId": "Benutzer-ID",
  "admin.errors.filter.userIdPlaceholder": "Nach Benutzer-ID suchen",
  "admin.errors.filter.search": "Freie Suche",
  "admin.errors.filter.searchPlaceholder": "In Nachricht, Stack Trace, Metadaten suchen...",
  "admin.errors.filter.statusCode": "Statuscode",
  "admin.errors.filter.occurredFrom": "Von Datum",
  "admin.errors.filter.occurredTo": "Bis Datum",
  "admin.errors.col.occurredAt": "Zeitpunkt",
  "admin.errors.col.statusCode": "Status",
  "admin.errors.col.method": "Methode",
  "admin.errors.col.path": "Pfad",
  "admin.errors.col.functionName": "Funktion",
  "admin.errors.col.exceptionType": "Ausnahmetyp",
  "admin.errors.col.message": "Nachricht",
  "admin.errors.col.userId": "Benutzer-ID",
  "admin.errors.col.invocationId": "Invocation-ID",
  "admin.errors.col.stackTrace": "Stack Trace",
  "admin.errors.col.metadata": "Metadaten",
  "admin.pagination.summary": "{start}-{end} von {total}",
  "admin.pagination.page": "Seite {page} von {totalPages}",
  "admin.pagination.previous": "Zurück",
  "admin.pagination.next": "Weiter",
  "admin.pagination.noResults": "0 Ergebnisse",
  "admin.subscription.currentSummary": "Aktuelle Abonnementdetails",
  "admin.subscription.currentPlan": "Plan",
  "admin.subscription.provider": "Abrechnungsquelle",
  "admin.subscription.customerId": "Provider-Kunden-ID",
  "admin.subscription.status": "Status",
  "admin.subscription.startsAt": "Beginn",
  "admin.subscription.endsAt": "Ende",
  "admin.subscription.none": "Keine",
  "admin.subscription.formTitle": "Abonnement manuell anpassen",
  "admin.subscription.formDescription": "Legen Sie für dieses Konto einen Abonnementzeitraum ohne Zahlung fest. Konten mit einem providerverwalteten Abonnement müssen zuerst beendet oder abgelaufen sein.",
  "admin.subscription.plan": "Abonnement",
  "admin.subscription.interval": "Intervall",
  "admin.subscription.interval.monthly": "Monatlich",
  "admin.subscription.interval.yearly": "Jährlich",
  "admin.subscription.startDate": "Startdatum",
  "admin.subscription.endDate": "Enddatum",
  "admin.subscription.noPlans": "Derzeit sind keine Abonnements zur Auswahl verfügbar.",
  "admin.subscription.loadPlansError": "Die Abonnementoptionen konnten nicht geladen werden.",
  "admin.subscription.saveError": "Die Abonnementänderung konnte nicht gespeichert werden.",
  "admin.subscription.periodError": "Das Enddatum muss nach dem Startdatum liegen.",
  "admin.subscription.required": "Füllen Sie alle Abonnementfelder aus.",
  "admin.subscription.protectedTitle": "Das Abonnement des Admin-Kontos ist geschutzt",
  "admin.subscription.protectedBody": "Benutzer mit der Rolle Admin konnen im Admin-Bereich kein manuelles Abonnement erhalten.",
  "admin.subscription.status.active": "Aktiv",
  "admin.subscription.status.pastDue": "Überfällig",
  "admin.subscription.status.canceled": "Beendet",
  "admin.subscription.status.trialing": "Testphase",
  "admin.subscription.startAccess": "Neue bezahlte Starts",
  "admin.subscription.startAllowed": "Erlaubt",
  "admin.subscription.startBlocked": "Blockiert",
  "admin.userDelete.sectionTitle": "Benutzer dauerhaft löschen",
  "admin.userDelete.sectionDescription": "Löschen Sie diesen Benutzer nur, wenn das gesamte Konto und alle verknüpften Daten dauerhaft entfernt werden dürfen.",
  "admin.userDelete.openButton": "Benutzer löschen",
  "admin.userDelete.dialogTitle": "Benutzer dauerhaft löschen",
  "admin.userDelete.warningTitle": "Warnung: Diese Aktion kann nicht rückgängig gemacht werden.",
  "admin.userDelete.warningIntro": "Sie sind dabei, das Konto von {email} dauerhaft zu löschen.",
  "admin.userDelete.consequenceData": "Alle Daten dieses Benutzers werden aus dem Admin-Bereich und aus allen verknüpften Tabellen entfernt.",
  "admin.userDelete.consequenceFiles": "Alle verknüpften Dateien wie Fotos, Dokumente und Rechnungsdateien werden ebenfalls gelöscht.",
  "admin.userDelete.consequenceBilling": "Aktive providerverwaltete Abonnements werden zuerst beendet, damit keine weiteren Belastungen entstehen.",
  "admin.userDelete.consequenceIrreversible": "Nach der Bestätigung kann dieser Benutzer nicht wiederhergestellt werden.",
  "admin.userDelete.confirmLabel": "Endgültig löschen",
  "admin.userDelete.deleteError": "Der Benutzer konnte nicht gelöscht werden.",
  "common.export": "Exportieren",
  "common.generating": "Wird erstellt...",
  "dossier.buttonShort": "Dossier",
  "dossier.property.modalTitle": "Vermieterdossier exportieren",
  "dossier.property.modalDescription": "Wählen Sie, welche Bereiche in das PDF für diese Immobilie aufgenommen werden.",
  "dossier.property.section.summary": "Immobilienübersicht",
  "dossier.property.section.tenants": "Mieter und Kontaktdaten",
  "dossier.property.section.documents": "Dokumentenübersicht",
  "dossier.property.section.reminders": "Erinnerungen",
  "dossier.tenant.modalTitle": "Mieterdossier exportieren",
  "dossier.tenant.modalDescription": "Wählen Sie, welche Bereiche in das PDF für diesen Mieter aufgenommen werden.",
  "dossier.tenant.section.contact": "Kontaktdaten",
  "dossier.tenant.section.agreements": "Mietverträge",
  "dossier.tenant.section.documents": "Dokumente",
  "dossier.tenant.section.timeline": "Chronik",
  "dossier.tenant.section.reminders": "Verknüpfte Erinnerungen",
  "dossier.error.emptySelection": "Wählen Sie mindestens einen Bereich für den Export aus.",
  "dossier.error.exportFailed": "Das PDF konnte nicht erstellt werden.",
  "nav.contracts": "Zeitplan",
  "pages.contracts.title": "Vertragsübersicht",
  "contractTimeline.title": "Vertragsübersicht",
  "contractTimeline.subtitle": "Visuelle Übersicht aller Mietverträge pro Objekt",
  "contractTimeline.today": "Heute",
  "contractTimeline.openEnded": "kein Enddatum",
  "contractTimeline.vacant": "Leer",
  "contractTimeline.noProperties": "Sie haben noch keine Objekte hinzugefügt.",
  "contractTimeline.addProperty": "Objekt hinzufügen",
  "contractTimeline.loadError": "Fehler beim Laden der Übersicht",
  "contractTimeline.legend.active": "Aktiv",
  "contractTimeline.legend.endingSoon": "Endet in 3 Monaten",
  "contractTimeline.legend.ended": "Beendet",
  "contractTimeline.legend.inactive": "Inaktiv",
  "contractTimeline.legend.vacant": "Leer / kein Vertrag",
  "notifications.triggerAriaLabel": "Benachrichtigungen offnen",
  "notifications.title": "Benachrichtigungen",
  "notifications.unreadCount": "{count} ungelesen",
  "notifications.markAllRead": "Alle als gelesen markieren",
  "notifications.deleteAllAriaLabel": "Alle Benachrichtigungen loschen",
  "notifications.deleteSingleAriaLabel": "Benachrichtigung loschen",
  "notifications.confirmDeleteSingle": "Mochten Sie diese Benachrichtigung loschen?",
  "notifications.confirmDeleteAll": "Mochten Sie alle Benachrichtigungen loschen?",
  "notifications.hiddenUnreadCount": "Noch {count} altere ungelesene Benachrichtigungen",
  "notifications.showAllUnread": "Alle ungelesenen anzeigen",
  "notifications.showFewerUnread": "Weniger anzeigen",
  "notifications.readSection": "Zuletzt gelesen",
  "notifications.empty": "Noch keine Benachrichtigungen.",
  "notifications.loadError": "Benachrichtigungen konnten nicht geladen werden.",
  "notifications.generic.title": "Neues Update",
  "notifications.generic.message": "Offnen Sie die Benachrichtigung fur die Details.",
  "notifications.tenantApplicationAssigned.title": "Neue Bewerbung",
  "notifications.tenantApplicationAssigned.message": "{propertyAddress} wurde Ihrem Mieterportal als Bewerbung hinzugefugt.",
  "notifications.tenantAgreementAssigned.title": "Neuer Mietvertrag",
  "notifications.tenantAgreementAssigned.message": "{propertyAddress} wurde Ihrem Mieterportal hinzugefugt.",
  "notifications.tenantAgreementUpdated.title": "Mietvertrag aktualisiert",
  "notifications.tenantAgreementUpdated.message": "Es gibt neue Details fur {propertyAddress}. Offnen Sie den Vertrag, um sie anzusehen.",
  "notifications.tenantAgreementEndingSoon.title": "Mietvertrag endet bald",
  "notifications.tenantAgreementEndingSoon.message": "Ihr Mietvertrag fur {propertyAddress} endet am {endDate}.",
  "notifications.reminderOverdue.title": "Erinnerung uberfallig",
  "notifications.reminderOverdue.message": "{title} ist seit {dueDate} uberfallig.",
  "notifications.surveyResponse.title": "Umfrage ausgefullt",
  "notifications.surveyResponse.message": "{tenantName} hat die Zufriedenheitsumfrage fur {year} ausgefullt.",
  "notifications.damageReportCreated.title": "Neue Schadensmeldung",
  "notifications.damageReportCreated.message": "{tenantName} hat ein Problem fuer {propertyAddress} gemeldet.",
  "survey.sectionTitle": "Zufriedenheitsumfrage",
  "survey.sendButton": "Umfrage senden",
  "survey.resendButton": "Erneut senden",
  "survey.sending": "Senden...",
  "survey.sendSuccess": "Umfrage gesendet",
  "survey.sendError": "Senden fehlgeschlagen",
  "survey.alreadySentThisYear": "Bereits dieses Jahr gesendet",
  "survey.onlyLatestAgreementYear": "Nur im letzten aktiven Mietjahr",
  "survey.noEmail": "Mieter hat keine E-Mail-Adresse",
  "survey.noEmailHint": "Es ist nicht möglich, eine Umfrage zu senden, wenn keine E-Mail-Adresse des Mieters verfügbar ist.",
  "survey.rating": "Bewertung",
  "survey.comment": "Kommentar",
  "survey.answered": "Beantwortet",
  "survey.pending": "Warte auf Antwort",
  "survey.year": "Jahr",
  "survey.noResults": "Noch keine Umfragen gesendet",
  "survey.stars": "Sterne",
  "site.title": "Rentomax",
  "agreement.editTitle": "Mietvertrag bearbeiten",
  "agreement.updateError": "Der Mietvertrag konnte nicht aktualisiert werden.",
  "common.daysShort": "{count}T",
  "common.daysAgo": "vor {count} Tagen",
  "common.daysRemaining": "{count} Tage verbleibend",
  "common.processing": "Wird verarbeitet...",
  "common.rentAmountPerMonth": "Miete (EUR/Monat)",
  "common.rentAmountPlaceholder": "z. B. 850.00",
  "document.type.epc": "EPC",
  "onboarding.csvImportError": "Der Import ist fehlgeschlagen. Versuchen Sie es erneut mit der Vorlagendatei.",
  "onboarding.csvImportFileRequired": "W?hlen Sie zuerst die ausgef?llte CSV-Datei aus.",
  "onboarding.csvImportInvalidData": "Ung?ltige Daten.",
  "onboarding.csvImportRowError": "Zeile {rowNumber}: {message}",
  "onboarding.csvImportSuccess": "{propertyCount} Immobilien und {tenantCount} Mieter importiert.",
  "onboarding.document.description": "F?gen Sie ein erstes Dokument wie einen EPC-Nachweis, einen Mietvertrag oder eine Versicherungspolice hinzu. Sie k?nnen diesen Schritt auch ?berspringen.",
  "onboarding.document.fileDropHint": "PDF, JPG, PNG - max. 20 MB",
  "onboarding.document.fileDropIcon": "Datei",
  "onboarding.document.fileDropText": "Datei hier ablegen oder zum Ausw?hlen klicken",
  "onboarding.document.next": "Weiter: Erinnerung anlegen",
  "onboarding.document.optionalReplace": "(optional - ersetzt das aktuelle Dokument)",
  "onboarding.document.title": "Laden Sie ein erstes Dokument hoch",
  "onboarding.document.typeLabel": "Dokumenttyp",
  "onboarding.document.uploadedHint": "W?hlen Sie unten eine neue Datei aus, um sie zu ersetzen.",
  "onboarding.document.uploadedNotice": "Hochgeladen",
  "onboarding.error.complete": "Das Onboarding konnte nicht abgeschlossen werden.",
  "onboarding.error.companyNameRequired": "Geben Sie einen Firmennamen ein.",
  "onboarding.error.documentFileRequired": "W?hlen Sie eine Datei zum Hochladen oder ?berspringen Sie diesen Schritt.",
  "onboarding.error.profileRequired": "Geben Sie Stra?e, Hausnummer, Postleitzahl, Stadt und Land ein.",
  "onboarding.error.countryNotAllowed": "Dieses Land ist auf Rentomax nicht zugelassen.",
  "onboarding.error.propertyAddressRequired": "Geben Sie eine Adresse f?r die Immobilie ein.",
  "onboarding.error.reminderRequired": "Geben Sie eine Beschreibung und ein Datum ein oder ?berspringen Sie diesen Schritt.",
  "onboarding.error.tenantRequired": "F?llen Sie die erforderlichen Mieterdaten aus oder ?berspringen Sie diesen Schritt.",
  "onboarding.error.vatNumberRequired": "Geben Sie eine USt-Nummer ein.",
  "onboarding.profile.billingHelp": "Optional. Leer lassen, wenn diese Adresse mit Ihrer normalen Adresse identisch ist.",
  "onboarding.profile.description": "Wählen Sie Ihren Kontotyp und geben Sie Ihre Adressdaten ein. Für ein geschäftliches Konto sind Firmenname und USt-Nummer Pflicht, und Sie können optional eine Rechnungsadresse speichern.",
  "onboarding.profile.next": "Weiter: Immobilie hinzuf?gen",
  "onboarding.profile.title": "Vervollst?ndigen Sie Ihr Vermieterprofil",
  "onboarding.progressLabel": "{completed} von {total} abgeschlossen",
  "onboarding.property.description": "Geben Sie die Adresse der Immobilie ein, die Sie verwalten. Weitere Immobilien k?nnen Sie sp?ter jederzeit hinzuf?gen.",
  "onboarding.property.next": "Weiter: Mieter hinzuf?gen",
  "onboarding.property.title": "F?gen Sie Ihre erste Immobilie hinzu",
  "onboarding.property.typeLabel": "Immobilientyp",
  "onboarding.reminder.title": "Erstellen Sie eine erste Erinnerung",
  "onboarding.reminder.description": "Erinnerungen helfen Ihnen, Fristen und Aufgaben im Blick zu behalten. Legen Sie jetzt schon eine an.",
  "onboarding.reminder.suggestionsLabel": "Schnelle Vorschl?ge:",
  "onboarding.reminder.suggestion.epcLabel": "EPC erneuern",
  "onboarding.reminder.suggestion.epcTitle": "EPC-Nachweis erneuern",
  "onboarding.reminder.suggestion.electricalLabel": "Elektropr?fung",
  "onboarding.reminder.suggestion.electricalTitle": "Elektropr?fung",
  "onboarding.reminder.suggestion.insuranceLabel": "Feuerversicherung",
  "onboarding.reminder.suggestion.insuranceTitle": "Feuerversicherung verl?ngern",
  "onboarding.reminder.suggestion.indexationLabel": "Mietindexierung",
  "onboarding.reminder.suggestion.indexationTitle": "Mietindexierung verfolgen",
  "onboarding.reminder.titlePlaceholder": "Z. B. EPC-Nachweis erneuern",
  "onboarding.reminder.checkoutDescription": "Nach diesem Schritt leiten wir Sie zu Mollie weiter, um Ihr Abonnement zu starten.",
  "onboarding.reminder.dashboardDescription": "Nach diesem Schritt schliessen wir Ihr Onboarding ab und bringen Sie direkt mit Ihrer Testversion zum Dashboard.",
  "onboarding.reminder.skipCheckout": "Schritt uberspringen - zu Mollie",
  "onboarding.reminder.finishCheckout": "Fertig - zu Mollie",
  "onboarding.reminder.finishDashboard": "Fertig - zum Dashboard",
  "onboarding.reminder.finish": "Fertig - zum Dashboard",
  "onboarding.sidebarSubtitle": "Folgen Sie diesen {count} Schritten, um alles einzurichten. In Ihrem Profil w?hlen Sie zwischen einem privaten oder gesch?ftlichen Konto und geben Ihre Adressdaten ein.",
  "onboarding.sidebarTitle": "Schnell startklar",
  "onboarding.skipStep": "Schritt ?berspringen",
  "onboarding.step.document": "Dokument",
  "onboarding.step.profile": "Profil",
  "onboarding.step.property": "Immobilie",
  "onboarding.step.reminder": "Erinnerung",
  "onboarding.step.tenant": "Mieter",
  "onboarding.stepBadge": "Schritt {current} von {total}",
  "onboarding.tenant.description": "F?gen Sie den ersten Mieter f?r {property} hinzu.",
  "onboarding.tenant.descriptionNoProperty": "F?gen Sie den ersten Mieter f?r Ihre Immobilie hinzu.",
  "onboarding.tenant.firstNamePlaceholder": "Max",
  "onboarding.tenant.lastNamePlaceholder": "Mustermann",
  "onboarding.tenant.next": "Weiter: Dokument hinzuf?gen",
  "onboarding.tenant.title": "Mieter verkn?pfen",
  "property.addressPlaceholder": "Stra?e 1, 1000 Stadt",
  "property.form.structureType": "Struktur",
  "property.form.name": "Name",
  "property.form.namePlaceholder": "Zum Beispiel Residenz Parkzicht",
  "property.form.unitLabel": "Einheitslabel",
  "property.form.unitLabelPlaceholder": "Zum Beispiel 1A",
  "property.form.units": "Einheiten",
  "property.form.unitsPlaceholder": "1A\n1B\n2A",
  "property.form.unitsHint": "Fugen Sie pro Zeile ein Einheitslabel hinzu. Jede Einheit erhalt ihr eigenes Dossier.",
  "property.structure.standalone": "Einzelobjekt",
  "property.structure.building": "Gebaude mit Einheiten",
  "property.structure.unit": "Einheit",
  "property.descriptionPlaceholder": "Optionale Beschreibung...",
  "property.documents.empty": "Keine Dokumente f?r diese Immobilie.",
  "property.notifications.sectionTitle": "Benachrichtigungseinstellungen pro Immobilie",
  "property.notifications.sectionDescription": "Legen Sie pro Erinnerungstyp fest, ob eine Warnung erscheint und wie weit im Voraus.",
  "property.notifications.leadTimeLabel": "Vorlaufzeit fur {label}",
  "property.notifications.unit.days": "Tage",
  "property.notifications.unit.months": "Monate",
  "property.notifications.contractEnd.label": "Vertragsende",
  "property.notifications.contractEnd.hint": "Vor dem Ende eines aktiven Mietvertrags warnen.",
  "property.notifications.epcExpiry.label": "EPC-Ablauf",
  "property.notifications.epcExpiry.hint": "Vor dem Ablauf des verknupften EPC-Dokuments warnen.",
  "property.notifications.insuranceExpiry.label": "Versicherung",
  "property.notifications.insuranceExpiry.hint": "Vor dem Ablauf eines Versicherungsdokuments warnen.",
  "property.form.addTitle": "Neue Immobilie",
  "property.form.documentTypeLabel": "Dokumenttyp",
  "property.form.editTitle": "Immobilie bearbeiten",
  "property.form.linkTenantButton": "Mieter verkn?pfen",
  "property.form.linkTenantTitle": "Bestehenden Mieter verkn?pfen",
  "property.form.noAvailableTenants": "Keine verf?gbaren Mieter zum Verkn?pfen.",
  "property.form.addTenantError": "Der Mieter konnte nicht hinzugefuegt werden.",
  "property.form.linkTenantError": "Der Mieter konnte nicht verknuepft werden.",
  "property.form.reminderError": "Die Erinnerung konnte nicht gespeichert werden.",
  "property.reminders.empty": "Keine Erinnerungen f?r diese Immobilie.",
  "property.tenants.addButton": "Neuer Mieter",
  "property.tenants.linkExistingButton": "Vorhandenen verkn?pfen",
  "property.tenants.empty": "Keine Mieter mit dieser Immobilie verkn?pft.",
  "survey.public.answeredBody": "Ihre Antwort f?r {year} wurde bereits gespeichert. Vielen Dank!",
  "survey.public.answeredTitle": "Sie haben bereits geantwortet",
  "survey.public.commentPlaceholder": "Optionaler Kommentar...",
  "survey.public.errorBody": "Versuchen Sie, die Seite erneut zu laden.",
  "survey.public.errorTitle": "Etwas ist schiefgelaufen",
  "survey.public.formTitle": "Wie zufrieden sind Sie mit Ihrer Mietwohnung und dem Service?",
  "survey.public.loading": "Wird geladen...",
  "survey.public.notFoundBody": "Dieser Link ist ung?ltig oder abgelaufen.",
  "survey.public.notFoundTitle": "Umfrage nicht gefunden",
  "survey.public.ratingError": "Bitte w?hlen Sie eine Bewertung (1-5 Sterne).",
  "survey.public.starLabel": "{count} Stern",
  "survey.public.submit": "Meine Antwort senden",
  "survey.public.submittedBody": "Ihre Antwort wurde an {landlordName} gesendet.",
  "survey.public.submittedTitle": "Vielen Dank f?r Ihr Feedback!",
  "survey.public.submitting": "Wird gesendet...",
  "tenant.documents.empty": "Keine Dokumente f?r diesen Mieter.",
  "tenant.form.addTitle": "Neuer Mieter",
  "tenant.form.lastName": "Nachname",
  "tenant.timeline.allAgreements": "Alle Mietvertr?ge",
  "timeline.confirmDelete": "M?chten Sie dieses Ereignis wirklich l?schen?",
  "waitinglist.form.addTitle": "Neuer Kandidat",
  "waitinglist.form.convertDescription": "Der Kandidat wird in einen aktiven Mieter umgewandelt. Legen Sie unten die Mietbedingungen fest. Nach der Umwandlung kann die Kandidatenkarte nicht mehr bearbeitet werden.",
  "waitinglist.form.convertSubmit": "In {status} umwandeln",
  "waitinglist.form.convertTitle": "In {status} umwandeln",
  "waitinglist.form.saveError": "Der Kandidat konnte nicht gespeichert werden.",
  "waitinglist.form.convertError": "Der Kandidat konnte nicht umgewandelt werden.",
  "waitinglist.deleteError": "Der Kandidat konnte nicht geloescht werden.",
  "waitinglist.form.editTitle": "Kandidat bearbeiten",
  "waitinglist.form.interestDateLabel": "Interessensdatum",
  "waitinglist.form.loadingKnownPersons": "Bekannte Personen werden geladen...",
  "waitinglist.form.noKnownPersons": "Keine bekannten Personen",
  "waitinglist.form.rentomaxLookupHint": "Fugen Sie eine E-Mail-Adresse hinzu, um zu prufen, ob dieser Kandidat bereits ein Rentomax-Konto hat.",
  "waitinglist.form.rentomaxLookupLoading": "Rentomax-Konto wird gepruft...",
  "waitinglist.form.rentomaxLookupError": "Das Rentomax-Konto konnte nicht gepruft werden. Sie konnen ohne Verknupfung fortfahren.",
  "waitinglist.form.rentomaxKnownAccount": "Dieser Kandidat hat bereits ein Rentomax-Konto uber {provider}.",
  "waitinglist.form.rentomaxNoAccount": "Dieser Kandidat hat noch kein Rentomax-Konto. Sie konnen eine kostenlose Einladung senden, und die Anmeldung ist per E-Mail, Google oder Microsoft moglich.",
  "waitinglist.form.rentomaxActionLabel": "Rentomax-Verknupfung",
  "waitinglist.form.rentomaxAction.noneTitle": "Nicht verknupfen",
  "waitinglist.form.rentomaxAction.noneDescriptionKnown": "Speichern Sie diesen Kandidaten nur fur den Vermieter. Der Kandidat sieht nichts im Mieterportal.",
  "waitinglist.form.rentomaxAction.noneDescriptionUnknown": "Speichern Sie diesen Kandidaten nur fur den Vermieter, ohne eine Rentomax-Einladung zu senden.",
  "waitinglist.form.rentomaxAction.linkTitle": "Bestehendes Rentomax-Konto verknupfen",
  "waitinglist.form.rentomaxAction.linkDescription": "Zeigen Sie die Bewerbung sofort im Mieterportal an und senden Sie eine Rentomax-Benachrichtigung.",
  "waitinglist.form.rentomaxAction.inviteTitle": "Kostenloses Rentomax-Konto einladen",
  "waitinglist.form.rentomaxAction.inviteDescription": "Senden Sie eine kostenlose Einladung. Die Kontoerstellung ist per E-Mail, Google oder Microsoft moglich.",
  "waitinglist.form.notesPlaceholder": "Details, Hinweise...",
  "waitinglist.form.personLabel": "Person",
  "waitinglist.form.personModeExistingDescription": "W?hlen Sie jemanden, der bereits in Rentomax gespeichert ist.",
  "waitinglist.form.personModeExistingTitle": "Bekannte Person",
  "waitinglist.form.personModeNewDescription": "F?gen Sie einen Kandidaten mit neuen Kontaktdaten hinzu.",
  "waitinglist.form.personModeNewTitle": "Neue Person",
  "waitinglist.form.selectPerson": "Person ausw?hlen",
  "waitinglist.form.selectPlaceholder": "-- Ausw?hlen --",
  "agreement.rentChange.currentAgreementStep": "Aktueller<br>Vertrag",
  "agreement.rentChange.newAgreementStep": "Neuer<br>Vertrag",
  "agreement.rentChange.confirmStep": "Best?tigung",
  "agreement.rentChange.closeCurrentHelp": "Beenden Sie den aktuellen Vertrag, indem Sie ein Enddatum eingeben.",
  "agreement.rentChange.setupNewHelp": "Legen Sie den neuen Vertrag fest, der nach dem Abschluss beginnt.",
  "agreement.rentChange.reviewHelp": "Pr?fen Sie die ?nderungen und best?tigen Sie sie.",
  "agreement.rentChange.newRentAmount": "Neue Miete (EUR/Monat)",
  "agreement.rentChange.title": "Miete ?ndern",
  "agreement.rentChange.error": "Die Mietaenderung konnte nicht gespeichert werden.",
  "agreement.rentChange.currentEndDate": "Enddatum des aktuellen Vertrags",
  "agreement.rentChange.newStartDate": "Startdatum des neuen Vertrags",
  "common.rentAmount": "Miete",
  "tenantWelcome.sectionTitle": "Willkommensseite",
  "tenantWelcome.manageButton": "Willkommensseite",
  "tenantWelcome.status.notConfigured": "Nicht eingerichtet",
  "tenantWelcome.status.inactive": "Inaktiv",
  "tenantWelcome.status.active": "Aktiv",
  "tenantWelcome.status.ended": "Fur fruheren Mieter gesperrt",
  "tenantWelcome.publicLink": "Personlicher Link",
  "tenantWelcome.linkUnavailable": "Speichere zuerst die Willkommensseite, um einen personlichen Link zu erstellen.",
  "tenantWelcome.help": "Bundle wiederkehrende praktische Informationen fur diesen Mieter auf einer personlichen Seite ohne Konto. Der Link zeigt immer die neueste Version.",
  "tenantWelcome.pageTitle": "Titel",
  "tenantWelcome.pageTitlePlaceholder": "Willkommen in deinem Zuhause",
  "tenantWelcome.introduction": "Einleitung",
  "tenantWelcome.introductionPlaceholder": "Kurzer Willkommensgruss oder erste praktische Erklarung...",
  "tenantWelcome.houseRules": "Hausregeln",
  "tenantWelcome.houseRulesPlaceholder": "Zum Beispiel: Gemeinschaftsbereiche sauber halten, Ruhe nach 22 Uhr...",
  "tenantWelcome.wifiName": "WLAN-Netzwerk",
  "tenantWelcome.wifiNamePlaceholder": "Name des WLAN-Netzwerks",
  "tenantWelcome.wifiPassword": "WLAN-Passwort",
  "tenantWelcome.wifiPasswordPlaceholder": "WLAN-Passwort",
  "tenantWelcome.trashCollectionInfo": "Mullabfuhr",
  "tenantWelcome.trashCollectionPlaceholder": "Welcher Tag, welche Tonnen und wo sie hingestellt werden mussen...",
  "tenantWelcome.parkingInfo": "Parkinfos",
  "tenantWelcome.parkingPlaceholder": "Wo darf der Mieter parken? Braucht er einen Badge oder Code?",
  "tenantWelcome.additionalInfo": "Zusatzliche Infos",
  "tenantWelcome.additionalInfoPlaceholder": "Alles Weitere, was hilft: Keller, Zahlerstande, Fahrradraum...",
  "tenantWelcome.contactsTitle": "Notfallkontakte",
  "tenantWelcome.addContact": "Kontakt hinzufugen",
  "tenantWelcome.contactLabelPlaceholder": "Zum Beispiel Klempner",
  "tenantWelcome.contactNamePlaceholder": "Name",
  "tenantWelcome.contactPhonePlaceholder": "Telefonnummer",
  "tenantWelcome.saveDraft": "Speichern",
  "tenantWelcome.activateButton": "Aktivieren",
  "tenantWelcome.inactiveWarning": "Diese Willkommensseite ist derzeit nicht aktiv.",
  "tenantWelcome.deactivateButton": "Deaktivieren",
  "tenantWelcome.copyLink": "Link kopieren",
  "tenantWelcome.copySuccess": "Link kopiert.",
  "tenantWelcome.copyError": "Link konnte nicht kopiert werden.",
  "tenantWelcome.qrTitle": "QR-Code fur Mieter",
  "tenantWelcome.qrHelp": "Dieser QR-Code offnet direkt die offentliche Willkommensseite und das offentliche Schadenformular fur diesen Mieter.",
  "tenantWelcome.qrAlt": "QR-Code zur offentlichen Willkommensseite",
  "tenantWelcome.qrError": "Der QR-Code konnte nicht erstellt werden.",
  "tenantWelcome.printQr": "QR-Code drucken",
  "tenantWelcome.printQrError": "Das Druckfenster konnte nicht geoffnet werden.",
  "tenantWelcome.printTitle": "QR-Code fur Mieter",
  "tenantWelcome.qrPrintEyebrow": "Scannen, um Schaden zu melden",
  "tenantWelcome.qrPrintBody": "Scannen Sie diesen Code, um die offentliche Willkommensseite und das Schadenformular fur diese Wohnung zu offnen.",
  "tenantWelcome.openPublicPage": "Offentliche Seite offnen",
  "tenantWelcome.endedTenantWarning": "Dieser Mieter hat kein aktives Mietverhaltnis mehr. Die offentliche Seite bleibt blockiert, bis wieder eine aktive Mietperiode besteht.",
  "tenantWelcome.updatedAt": "Letzte Aktualisierung",
  "tenantWelcome.public.loading": "Wird geladen...",
  "tenantWelcome.public.notFoundTitle": "Willkommensseite nicht gefunden",
  "tenantWelcome.public.notFoundBody": "Dieser Link ist ungueltig oder deaktiviert.",
  "tenantWelcome.public.errorTitle": "Etwas ist schiefgelaufen",
  "tenantWelcome.public.errorBody": "Versuche, die Seite neu zu laden.",
  "tenantWelcome.public.wifiTitle": "WLAN",
  "tenantWelcome.public.damageReport.title": "Schaden melden",
  "tenantWelcome.public.damageReport.helper": "Melden Sie hier schnell einen Schaden oder ein Problem fur diese Wohnung. Der Vermieter erhalt die Meldung direkt in der Akte.",
  "tenantWelcome.public.damageReport.noLogin": "Ohne Login",
  "tenantWelcome.public.damageReport.descriptionLabel": "Was ist passiert?",
  "tenantWelcome.public.damageReport.descriptionPlaceholder": "Beschreiben Sie kurz, was beschadigt ist oder wo sich das Problem befindet.",
  "tenantWelcome.public.damageReport.urgencyLabel": "Dringlichkeit",
  "tenantWelcome.public.damageReport.photosLabel": "Fotos hinzufugen",
  "tenantWelcome.public.damageReport.submit": "Schadensmeldung senden",
  "tenantWelcome.public.damageReport.submitError": "Die Schadensmeldung konnte nicht gesendet werden.",
  "tenantWelcome.public.damageReport.success": "Ihre Meldung wurde gesendet. Der Vermieter kann sie jetzt nachverfolgen.",
  "publicProperty.loading": "Wird geladen...",
  "publicProperty.notFoundTitle": "Objektseite nicht gefunden",
  "publicProperty.notFoundBody": "Dieser Link ist ungultig, deaktiviert oder abgelaufen.",
  "publicProperty.errorTitle": "Etwas ist schiefgelaufen",
  "publicProperty.errorBody": "Versuchen Sie, die Seite neu zu laden.",
  "publicProperty.hostedBy": "Geteilt von {name}",
  "publicProperty.noDescription": "Der Vermieter hat fur dieses Objekt noch keine zusatzliche Beschreibung hinterlegt.",
  "publicProperty.previewType": "Typ",
  "publicProperty.previewStatus": "Status",
  "publicProperty.photosCount": "Fotos",
  "publicProperty.galleryTitle": "Fotogalerie",
  "publicProperty.gallerySubtitle": "Ein erster Eindruck vom Objekt, wie es der Vermieter prasentiert.",
  "publicProperty.galleryEmpty": "Fur dieses Objekt sind noch keine Fotos verfugbar.",
  "publicProperty.galleryPhotoAlt": "Objektfoto: {{fileName}}",
  "publicProperty.openPreview": "Objektfoto {{fileName}} öffnen",
  "publicProperty.lightboxTitle": "Objektfoto vergrößern",
  "publicProperty.closePreview": "Fotovorschau schließen",
  "publicProperty.previous": "Vorheriges Foto",
  "publicProperty.next": "Nächstes Foto",
  "publicProperty.position": "Foto {{current}} von {{total}}",
  "insurance.tabTitle": "Versicherungen",
  "insurance.add": "Versicherung hinzufügen",
  "insurance.new": "Neue Versicherung",
  "insurance.edit": "Versicherung bearbeiten",
  "insurance.empty": "Noch keine Versicherungen für diese Immobilie hinzugefügt.",
  "insurance.loadError": "Fehler beim Laden der Versicherungen.",
  "insurance.confirmDelete": "Möchten Sie diese Versicherung wirklich löschen?",
  "insurance.companyName": "Versicherungsgesellschaft",
  "insurance.companyNamePlaceholder": "z.B. AG Insurance, KBC, Axa",
  "insurance.policyNumber": "Policennummer",
  "insurance.policyNumberPlaceholder": "z.B. POL-2024-12345",
  "insurance.notesPlaceholder": "Optionale Anmerkungen...",
  "insurance.type.Brandverzekering": "Feuerversicherung",
  "insurance.type.Aansprakelijkheid": "Haftpflicht",
  "insurance.type.Huurwaarborgverzekering": "Mietbürgschaftsversicherung",
  "insurance.type.Rechtsbijstand": "Rechtsbeistand",
  "auth.accountBlocked": "Dieses Konto wurde gesperrt. Bitte kontaktieren Sie den Helpdesk.",
  "admin.col.blocked": "Status",
  "admin.active": "Aktiv",
  "admin.blocked": "Gesperrt",
  "admin.userBlock.sectionTitle": "Zugang sperren",
  "admin.userBlock.sectionDescription": "Sperren Sie dieses Konto, um k?nftige Anmeldungen und den API-Zugriff sofort zu stoppen.",
  "admin.userBlock.blockButton": "Benutzer sperren",
  "admin.userBlock.unblockButton": "Benutzer entsperren",
  "admin.userBlock.dialogTitleBlock": "Benutzer sperren",
  "admin.userBlock.dialogTitleUnblock": "Benutzer entsperren",
  "admin.userBlock.warningTitleBlock": "Dieser Benutzer verliert sofort den Zugriff.",
  "admin.userBlock.warningTitleUnblock": "Dieser Benutzer erh?lt wieder Zugriff.",
  "admin.userBlock.warningIntroBlock": "Nach der Best?tigung sieht der Benutzer bei der Anmeldung, dass das Konto gesperrt ist und der Helpdesk kontaktiert werden muss.",
  "admin.userBlock.warningIntroUnblock": "Nach der Best?tigung kann sich der Benutzer mit dem bestehenden Konto wieder anmelden.",
  "admin.userBlock.confirmBlock": "Sperren",
  "admin.userBlock.confirmUnblock": "Entsperren",
  "admin.userBlock.saveError": "Der Sperrstatus konnte nicht gespeichert werden.",
  "admin.bulkSubscription.cancelSelected": "Auswahl stoppen",
  "admin.bulkSubscription.cancelAllPaid": "Alle bezahlten Abos stoppen",
  "admin.bulkSubscription.dialogTitleSelected": "Ausgewahlte Abos stoppen",
  "admin.bulkSubscription.dialogSubtitleSelected": "{count} Benutzer werden sofort gestoppt, anteilig erstattet und fur neue bezahlte Abos gesperrt.",
  "admin.bulkSubscription.dialogTitleAllPaid": "Alle bezahlten Abos stoppen",
  "admin.bulkSubscription.dialogSubtitleAllPaid": "Diese Aktion gilt fur alle Benutzer mit einem bezahlten Abo auf der gesamten Rentomax-Plattform.",
  "admin.bulkSubscription.warningTitle": "Diese Aktion stoppt Abos sofort.",
  "admin.bulkSubscription.warningBodySelected": "Nach der Bestatigung werden kunftige Verlangerungen sofort gestoppt, die verbleibende bezahlte Periode anteilig erstattet und diese Konten konnen kein neues bezahltes Abo mehr starten.",
  "admin.bulkSubscription.warningBodyAllPaid": "Nach der Bestatigung werden kunftige Verlangerungen plattformweit sofort gestoppt, die verbleibende bezahlte Periode anteilig erstattet und diese Konten konnen kein neues bezahltes Abo mehr starten.",
  "admin.bulkSubscription.confirmSelected": "Auswahl stoppen",
  "admin.bulkSubscription.confirmAllPaid": "Alles stoppen",
  "admin.bulkSubscription.confirmationLabel": "Geben Sie rentomax zur Bestatigung ein",
  "admin.bulkSubscription.confirmationPlaceholder": "rentomax",
  "admin.bulkSubscription.confirmationHelp": "Die Bestatigungsschaltflache wird erst aktiv, wenn Sie exakt rentomax eingeben.",
  "admin.bulkSubscription.confirmationMismatch": "Geben Sie exakt rentomax ein, um diese Aktion zu bestatigen.",
  "admin.bulkSubscription.saveError": "Die Massenstopsetzung der Abos konnte nicht ausgefuhrt werden.",
  "admin.protectedAccount.title": "Geschutztes Admin-Konto",
  "admin.protectedAccount.body": "Benutzer mit der Rolle Admin konnen kein manuelles Abonnement erhalten, weder gesperrt noch geloscht werden.",
  "publicProperty.applyTitle": "Als Kandidat bewerben",
  "publicProperty.applySubtitle": "Bestatigen Sie uber Rentomax, dass Sie sich fur diese Immobilie bewerben mochten.",
  "publicProperty.applySuccess": "Ihre Bewerbung wurde gespeichert. Der Vermieter sieht Sie jetzt als Kandidatmieter in Rentomax.",
  "publicProperty.applyLoginRequired": "Melden Sie sich per E-Mail, Google oder Microsoft an, bevor Sie sich bewerben.",
  "publicProperty.applyLoginButton": "Anmelden zum Bewerben",
  "publicProperty.applyLandlordModeBlocked": "Mit einem Vermieterkonto konnen Sie sich nicht bewerben. Wechseln Sie zuerst den Kontomodus auf der Seite Mein Profil.",
  "publicProperty.applyGoToProfile": "Zu Mein Profil",
  "publicProperty.applyOnboardingRequired": "Vervollstandigen Sie zuerst Ihr Mieterprofil mit Ihrem Namen und Ihrer Adresse.",
  "publicProperty.applyCompleteProfile": "Profil vervollstandigen",
  "publicProperty.applyConfirmPrompt": "Bestatigen Sie, dass Sie sich fur diese Immobilie bewerben mochten.",
  "publicProperty.applyConfirmButton": "Bewerbung bestatigen",
  "publicProperty.applyBrowserConfirm": "Mochten Sie sich fur diese Immobilie bewerben?",
  "publicProperty.applyError": "Ihre Bewerbung konnte nicht gespeichert werden.",
  "waitinglist.inviteButton": "Einladen",
  "waitinglist.inviteResendButton": "Erneut senden",
  "waitinglist.inviteSentLabel": "Einladung gesendet",
  "waitinglist.inviteDialogTitle": "Kandidatenmieter einladen",
  "waitinglist.inviteDialogFreeNote": "In der E-Mail wird klar gesagt, dass ein Mieterkonto bei Rentomax kostenlos ist und kostenlos bleibt.",
  "waitinglist.inviteDialogMessageLabel": "Personliche Nachricht in der E-Mail",
  "waitinglist.inviteDialogMessagePlaceholder": "Optional eine kurze personliche Nachricht hinzufugen.",
  "waitinglist.inviteSend": "Einladung senden",
  "waitinglist.inviteSending": "Einladung wird gesendet...",
  "waitinglist.inviteSuccess": "Die Einladung wurde gesendet. Direkter Link:",
  "waitinglist.inviteError": "Die Einladung konnte nicht gesendet werden.",
  "waitinglist.portalStatus.has-account-unlinked.label": "Rentomax bekannt, nicht verknupft",
  "waitinglist.portalStatus.has-account-unlinked.tooltip": "Der Kandidat hat bereits ein Rentomax-Konto, ist aber noch nicht mit dieser Bewerbung verknupft.",
  "waitinglist.portalStatus.no-account-unlinked.label": "Kein Rentomax, keine Verknupfung",
  "waitinglist.portalStatus.no-account-unlinked.tooltip": "Der Kandidat hat noch kein Rentomax-Konto und es gibt noch keine Verknupfung oder Einladung.",
  "waitinglist.portalStatus.has-account-linked.label": "Rentomax verknupft",
  "waitinglist.portalStatus.has-account-linked.tooltip": "Der Kandidat hat ein Rentomax-Konto und ist mit dieser Bewerbung verknupft.",
  "waitinglist.portalStatus.no-account-invite-sent.label": "Einladung gesendet",
  "waitinglist.portalStatus.no-account-invite-sent.tooltip": "Der Kandidat hat noch kein Rentomax-Konto. Eine kostenlose Einladung zur Anmeldung per E-Mail, Google oder Microsoft wurde bereits gesendet.",
  "tenantOnboarding.intro": "Erganzen Sie Ihren Namen und Ihre Adresse, bevor Sie sich bewerben.",
  "tenantOnboarding.firstName": "Vorname",
  "tenantOnboarding.lastName": "Nachname",
  "tenantOnboarding.saveAndContinue": "Speichern und fortfahren",
  "tenantOnboarding.requiredError": "Vervollstandigen Sie Vorname, Nachname und Adresse.",
  "tenantOnboarding.saveError": "Ihr Profil konnte nicht gespeichert werden.",
  "tenantInvite.title": "Erstellen Sie Ihr kostenloses Mieterkonto",
  "tenantInvite.subtitle": "Nutzen Sie diese Einladung, um Ihren Vorgang in Rentomax mit Ihrem eigenen Mieterkonto zu verknupfen.",
  "tenantInvite.freeNote": "Ihr Mieterkonto bei Rentomax ist vollstandig kostenlos und bleibt kostenlos.",
  "tenantInvite.invitedBySuffix": "hat Sie uber Rentomax eingeladen.",
  "tenantInvite.loginCta": "Weiter zur Anmeldung per E-Mail, Google oder Microsoft",
  "tenantInvite.claiming": "Diese Einladung wird mit Ihrem Mieterkonto verknupft...",
  "tenantInvite.success": "Ihre Einladung ist verknupft.",
  "tenantInvite.successBody": "Sie sehen diesen Vorgang jetzt auch in Ihrem Mieterportal.",
  "tenantInvite.portalCta": "Mein Mieterportal offnen",
  "tenantInvite.profileCta": "Mein Profil offnen",
  "tenantInvite.loadError": "Diese Einladung ist nicht verfugbar.",
  "tenantInvite.claimError": "Die Einladung konnte nicht verknupft werden.",
  "tenantPortal.title": "Meine Immobilien",
  "tenantPortal.description": "Hier sehen Sie die Immobilien, fur die Sie sich beworben haben, und die Mietverhaltnisse, die mit Ihrem Konto verknupft sind.",
  "tenantPortal.candidateTitle": "Bewerbungen",
  "tenantPortal.activeTitle": "Aktive Mietverhaltnisse",
  "tenantPortal.futureTitle": "Zukunftige Mietverhaltnisse",
  "tenantPortal.pastTitle": "Vergangene Mietverhaltnisse",
  "tenantPortal.eyebrow": "Mieterportal",
  "tenantPortal.activeDescription": "Ein klarer Überblick über alle Mietverhältnisse, die derzeit aktiv mit Ihrem Konto verknüpft sind.",
  "tenantPortal.futureDescription": "Sehen Sie, welche Mietverhältnisse bald starten, damit Sie den nächsten Schritt rechtzeitig planen können.",
  "tenantPortal.candidateDescription": "Verfolgen Sie, für welche Immobilien Sie sich beworben haben und bei welchen Vermietern Ihr Profil bereits bekannt ist.",
  "tenantPortal.pastDescription": "Ein ruhiges Archiv früherer Mietverhältnisse, die weiterhin mit Ihrem Kontoverlauf verknüpft bleiben.",
  "tenantPortal.currentSectionCount": "Einträge in diesem Bereich",
  "tenantPortal.navigationLabel": "Navigation im Mieterportal",
  "tenantPortal.statActive": "Jetzt aktiv",
  "tenantPortal.statUpcoming": "Startet später",
  "tenantPortal.statApplications": "Bewerbungen",
  "tenantPortal.statHistory": "Archiv",
  "tenantPortal.propertyStatus": "Immobilienstatus",
  "tenantPortal.interestDate": "Beworben seit",
  "tenantPortal.startDate": "Startdatum",
  "tenantPortal.endDate": "Enddatum",
  "tenantPortal.rentAmount": "Miete",
  "tenantPortal.viewWelcomePage": "Willkommensseite ansehen",
  "tenantPortal.notAvailable": "Noch nicht verfügbar",
  "tenantPortal.loading": "Ihr Mieterportal wird geladen...",
  "tenantPortal.loadError": "Das Mieterportal konnte nicht geladen werden.",
  "tenantPortal.emptyTitle": "Noch nichts anzuzeigen",
  "tenantPortal.emptyBody": "Sobald in dieser Kategorie etwas verknüpft ist, erscheint es hier automatisch.",
  "tenantPortal.empty": "Keine Immobilien in dieser Liste.",
  "tenantPortal.damageReports.title": "Schaden oder Problem melden",
  "tenantPortal.damageReports.helper": "Nutzen Sie dieses Formular, um ein Problem zu diesem aktiven Mietverhaltnis zu erfassen.",
  "tenantPortal.damageReports.empty": "Fuer dieses Mietverhaltnis gibt es noch keine Meldungen.",
  "tenantPortal.damageReports.descriptionLabel": "Problembeschreibung",
  "tenantPortal.damageReports.descriptionPlaceholder": "Beschreiben Sie, was passiert und wo sich das Problem befindet.",
  "tenantPortal.damageReports.photosLabel": "Fotos",
  "tenantPortal.damageReports.submit": "Meldung senden",
  "tenantPortal.damageReports.submitError": "Die Meldung konnte nicht gesendet werden.",
  "damageReports.pageDescription": "Hier sehen Sie alle Schadens- und Problemmeldungen, die Mieter fuer Ihre Immobilien eingereicht haben.",
  "damageReports.empty": "Es gibt noch keine Schadens- oder Problemmeldungen.",
  "damageReports.loadError": "Die Meldungen konnten nicht geladen werden.",
  "damageReports.propertyEmpty": "Fuer diese Immobilie gibt es noch keine Meldungen.",
  "damageReports.openPropertyDetail": "Immobiliendetails oeffnen",
  "damageReports.urgency.low": "Niedrige Dringlichkeit",
  "damageReports.urgency.normal": "Normale Dringlichkeit",
  "damageReports.urgency.high": "Hohe Dringlichkeit",
  "damageReports.urgency.urgent": "Dringend",
  "common.category": "Kategorie",
  "profile.accountModeTitle": "Kontomodus",
  "profile.accountModeTenantDescription": "Ihr Konto ist im Mietermodus. Sie konnen Ihre Bewerbungen und verknupften Mietverhaltnisse ohne Abonnement einsehen.",
  "profile.accountModeLandlordDescription": "Ihr Konto ist im Vermietermodus. Sie verwalten die kostenpflichtige Plattform und konnen jederzeit in den Mietermodus zuruckwechseln.",
  "profile.accountModeSwitchToLandlordTitle": "Zum Vermietermodus wechseln?",
  "profile.accountModeSwitchToLandlordConfirm": "Der Vermietermodus gibt Zugriff auf die kostenpflichtige Plattform. Fur diese Funktionen brauchen Sie ein bezahltes Abonnement.",
  "profile.accountModeSwitchToTenantTitle": "Zum Mietermodus wechseln?",
  "profile.accountModeSwitchToTenantConfirm": "Der Mietermodus ist nur dafur gedacht, selbst eine Immobilie von jemand anderem zu mieten. Nutzen Sie ihn fur Bewerbungen und Mietverhaltnisse.",
  "profile.switchToLandlord": "In den Vermietermodus wechseln",
  "profile.switchToTenant": "In den Mietermodus wechseln",
  "profile.accountModeTenantActivated": "Ihr Konto ist jetzt im Mietermodus.",
  "profile.accountModeLandlordActivated": "Ihr Konto ist jetzt im Vermietermodus.",
  "profile.accountModeLandlordTrialActivated": "Ihr Konto ist jetzt im Vermietermodus und Ihre Testphase hat begonnen.",
  "profile.accountModeSwitchError": "Der Kontomodus konnte nicht geandert werden.",
  "profile.accountMembers.title": "Kontomitglieder",
  "profile.accountMembers.description": "Geben Sie einem Partner, Familienmitglied oder Makler Zugriff auf dieselben Kontodaten.",
  "profile.accountMembers.empty": "Noch keine zusatzlichen Kontomitglieder.",
  "profile.accountMembers.pendingTitle": "Ausstehende Einladungen",
  "profile.accountMembers.emailLabel": "E-Mail-Adresse",
  "profile.accountMembers.roleLabel": "Rolle",
  "profile.accountMembers.role.owner": "Eigentumer",
  "profile.accountMembers.role.manager": "Mitverwalter",
  "profile.accountMembers.role.reader": "Leser",
  "profile.accountMembers.you": "Sie",
  "profile.accountMembers.inviteButton": "Einladung senden",
  "profile.accountMembers.inviteSent": "Die Einladung wurde gesendet.",
  "profile.accountMembers.inviteError": "Die Einladung konnte nicht gesendet werden.",
  "profile.accountMembers.claimSuccess": "Der Zugriff auf das geteilte Konto ist jetzt aktiv.",
  "profile.accountMembers.claimError": "Die Einladung konnte nicht aktiviert werden.",
  "profile.accountMembers.removeButton": "Entfernen",
  "profile.accountMembers.removeConfirm": "Dieses Kontomitglied aus dem geteilten Konto entfernen?",
  "profile.accountMembers.removeSuccess": "Das Kontomitglied wurde entfernt.",
  "profile.accountMembers.removeError": "Das Kontomitglied konnte nicht entfernt werden.",
  "profile.accountMembers.loadError": "Die Kontomitglieder konnten nicht geladen werden.",
  "profile.accountMembers.readerProfileNotice": "Sie haben Nur-Lese-Zugriff. Nur der Eigentumer oder ein Mitverwalter kann Kontodaten andern.",
  "profile.accountMembers.readerBillingNotice": "Sie haben Nur-Lese-Zugriff. Nur der Eigentumer oder ein Mitverwalter kann Abonnements verwalten.",
  "maintenanceActivities.tabTitle": "Wartungsprotokoll",
  "maintenanceActivities.add": "Aktivitat hinzufugen",
  "maintenanceActivities.empty": "Fuer diese Immobilie wurden noch keine Wartungsaktivitaten erfasst.",
  "maintenanceActivities.descriptionPlaceholder": "Beschreiben Sie, was passiert ist oder geplant ist.",
  "maintenanceActivities.amountOptional": "Betrag (optional)",
  "maintenanceActivities.attachmentOptional": "Anhang (optional)",
  "maintenanceActivities.planned": "Geplant",
  "maintenanceActivities.completed": "Erledigt",
  "maintenanceActivities.confirmDelete": "Moechten Sie diese Wartungsaktivitaet loeschen?",
  "maintenanceActivities.saveError": "Die Wartungsaktivitaet konnte nicht gespeichert werden.",
  "maintenanceActivities.uploadError": "Der Anhang konnte nicht hochgeladen werden.",
  "maintenanceActivities.category.maintenance": "Wartung",
  "maintenanceActivities.category.repair": "Reparatur",
  "maintenanceActivities.category.inspection": "Inspektion",
  "maintenanceActivities.category.renovation": "Renovierung",
  "maintenanceActivities.category.other": "Sonstiges",
  "common.undo": "Rueckgaengig",
  "property.renewals.title": "Vertragsverlaengerung",
  "property.renewals.subtitle": "Behalten Sie auslaufende Vertraege proaktiv im Blick und protokollieren Sie jeden Folgeschritt in der Zeitleiste.",
  "property.renewals.empty": "Fuer diese Immobilie gibt es noch keine Vertraege mit aktivem Verlaengerungs-Workflow.",
  "property.renewals.loadError": "Fehler beim Laden der Workflows zur Vertragsverlaengerung.",
  "property.renewals.updateError": "Fehler beim Aktualisieren des Workflows zur Vertragsverlaengerung.",
  "property.renewals.endsOn": "Endet am",
  "property.renewals.stage.sixMonths": "Innerhalb von 6 Monaten",
  "property.renewals.stage.threeMonths": "Innerhalb von 3 Monaten",
  "property.renewals.step.extendAgreement": "Verlaengern? Enddatum anpassen",
  "property.renewals.step.extendAgreementHint": "Aktualisieren Sie den Mietvertrag. Dieser Schritt wird automatisch abgeschlossen, sobald sich das Enddatum aendert.",
  "property.renewals.step.contactTenant": "Mieter kontaktieren? Kommunikation protokollieren",
  "property.renewals.step.contactTenantHint": "Halten Sie fest, dass Sie wegen der Vertragsverlaengerung Kontakt aufgenommen haben.",
  "property.renewals.step.markUpcomingVacancy": "Neuen Kandidaten suchen? Als bald frei markieren",
  "property.renewals.step.markUpcomingVacancyHint": "Halten Sie fest, dass Sie diese Immobilie bald wieder am Markt anbieten moechten.",
  "property.renewals.action.extendAgreement": "Enddatum anpassen",
  "property.renewals.action.contactTenant": "Kommunikation protokollieren",
  "property.renewals.action.markUpcomingVacancy": "Als bald frei markieren",
  "property.renewals.contactModalTitle": "Kommunikation protokollieren",
  "property.renewals.contactModalNote": "Notiz",
  "property.renewals.contactModalPlaceholder": "Zum Beispiel: Mieter wegen moeglicher Verlaengerung kontaktiert.",
  "timeline.contractRenewal.extendAgreementCompleted": "Vertragsverlaengerung: Enddatum angepasst",
  "timeline.contractRenewal.contactTenantLogged": "Vertragsverlaengerung: Kommunikation mit dem Mieter protokolliert",
  "timeline.contractRenewal.upcomingVacancyMarked": "Vertragsverlaengerung: Immobilie als bald frei markiert",
  "billing.newSubscriptionsDisabled": "Das Starten neuer Abonnements ist vorubergehend deaktiviert. Laufende Abonnements und automatische Verlangerungen laufen normal weiter.",
  "billing.userNewSubscriptionsDisabled": "Das Starten eines neuen bezahlten Abonnements ist fur dieses Konto deaktiviert. Kontaktieren Sie den Support, wenn das geandert werden muss.",
  "admin.newSubscriptionAccess.sectionTitle": "Neue Abonnements",
  "admin.newSubscriptionAccess.sectionDescription": "Steuern Sie, ob bestehende Konten ohne bezahltes Abonnement noch ein neues Abonnement starten durfen. Laufende Abonnements und automatische Verlangerungen laufen normal weiter.",
  "admin.newSubscriptionAccess.enabled": "Neue Abonnements zugelassen",
  "admin.newSubscriptionAccess.disabled": "Neue Abonnements blockiert",
  "admin.newSubscriptionAccess.toggleLabel": "Ein/aus",
  "admin.newSubscriptionAccess.saveError": "Die Einstellung fur neue Abonnements konnte nicht gespeichert werden.",
  "admin.allowedCountries.sectionTitle": "Erlaubte Lander",
  "admin.allowedCountries.sectionDescription": "Nur diese Lander durfen sich anmelden und in Landesfeldern auf der Plattform ausgewahlt werden.",
  "admin.allowedCountries.saveButton": "Lander speichern",
  "admin.allowedCountries.saveError": "Die erlaubten Lander konnten nicht gespeichert werden.",
  "admin.advertising.sectionTitle": "Rechte Anzeigenflache",
  "admin.advertising.sectionDescription": "Steuern Sie, ob Rentomax auf normalen Desktop-App-Seiten eine dezente vertikale Anzeigenflache zeigt. Admin-Seiten zeigen diese Flache nicht.",
  "admin.advertising.enabled": "Anzeigenflache sichtbar",
  "admin.advertising.disabled": "Anzeigenflache deaktiviert",
  "admin.advertising.toggleLabel": "Ein/aus",
  "admin.advertising.saveError": "Die Werbeeinstellung konnte nicht gespeichert werden."
}
